export var ApiUrls = {
  Login: {
    Login: "Login/Login",
    LoginToMSTeam: "Login/LoginToMSTeam",
    MsTeamRefreshToken: "Login/MsTeamRefreshToken",
    SaveAccesTokenForMsTeam: "Login/SaveAccesTokenForMsTeam",
    ATSLogin: "Login/ATSLogin",
    getAntiForgeryToken: "Login/GetAFT?autoRequest=jt",
    RefreshToken: "Login/RefreshToken?autoRequest=jt",
    AnonymousToken: "Login/AnonymousToken?autoRequest=jt",
    GetOwnSecurityRoleDetail: "SecurityRoles/GetOwnSecurityRoleDetail",
    SSOToken: "Login/SSOToken?autoRequest=jt",//"http://localhost:43344/api/Login/SSOToken",
    SSOLogin: "Login/SSOLogin?autoRequest=jt",
    ATSToken: "Login/ATSToken?autoRequest=jt",

    CASLogin: "api/Login/CASLogin?ngsw-bypass=true",
    OktaLogin: "api/Login/OktaLogin?ngsw-bypass=true",
    SSO: "SSOLogin",
    ApiSSOLogin: "api/Login/SSOLogin?ngsw-bypass=true",
    GetQrCode: "UserManagement/GetQrCode",
    VerifyAccessCode: "UserManagement/VerifyAccessCode",
    VerifyCode: "Login/VerifyAccessCode",
    Enable2FAForUser: "UserManagement/Enable2FAForUser?UserId=",
    EnableDisable2FAForUser: "UserManagement/EnableDisable2FAForUser",
  },
  System: {
    KeepAlive: "Home/KeepAlive",

  },

  ForgotPassword: {
    ForgotPassword: "SystemSettings/ForgotPassword?userName=",
    SendPasswordRemainder: "SystemSettings/SendPasswordRemainder?userName=",
    ForgotPasswordURl: "ForgotPassword",

    UpdatePassword: "updateUserPassword",


  },

  SystemCustomization: {
    Get: "SystemSettings/GetSystemCustomizations",
    Save: "SystemSettings/SaveSystemCustomizations"
  },
  SecurityRoles: {
    Save: "SecurityRoles/SaveSecurityRole",
    CreateGet: "SecurityRoles/GetSecurityRoleViewModel/",
    GetDetails: "SecurityRoles/GetSecurityRoleDetails",
    GetDetailsList: "SecurityRoles/GetSecurityRoleDetailsList"
  },
  CustomFields: {
    Save: "CustomFields/SaveCustomField",
    CreateGet: "CustomFields/GetCustomFieldsViewModel/"
  },
  ApplicationTemplates: {
    Get: "ApplicationTemplate/GetApplicationTemplateVM/",
    GetFirstEnabledTemplateSection: "ApplicationTemplate/GetFirstEnabledTemplateSection/",
    UpdateSave: "ApplicationTemplate/SaveApplicationTemplateVM",
    CreateSave: "ApplicationTemplate/SaveApplicationTemplate",
    UpdateSactionSave: "ApplicationTemplate/SaveApplicationTemplateSection",
    CustomFieldSave: "ApplicationTemplate/SaveTemplateCustomField",
    UpdateSactionDelete: "ApplicationTemplate/DeleteApplicationTemplateSection/",
    UpdateSactionGet: "ApplicationTemplate/ApplicationTemplateSectionSetting",
    UpdateSactionGetAll: "ApplicationTemplate/ApplicationTemplateSectionSettingAll",
    DeleteApplicationTemplate: "ApplicationTemplate/DeleteApplicationTemplate/",
    GetCustomFieldsByApplicationTemplateId: "ApplicationTemplate/GetCustomFieldsByApplicationTemplateId"
  },
  TalentPoolTemplate: {
    GetTalentPoolApplicationTemplate: "TalentPoolTemplate/GetTalentPoolApplicationTemplate/",
    SaveTalentPoolApplicationTemplate: "TalentPoolTemplate/SaveTalentPoolApplicationTemplate/",
    UpdateTalentPoolApplicationTemplate: "TalentPoolTemplate/UpdateTalentPoolApplicationTemplate/",
    GetTalentPoolApplicationTemplateListing: "TalentPoolTemplate/GetTalentPoolApplicationTemplateListing",
    DeleteCustomFieldFromTemplateById: "TalentPoolTemplate/DeleteCustomFieldFromTemplateById",
    GetCustomFieldsByTalentPoolApplicationTemplateId: "TalentPoolTemplate/GetCustomFieldsByTalentPoolApplicationTemplateId",
    GetTalentPoolTemplateDataForPreview: "TalentPoolTemplate/GetTalentPoolTemplateDataForPreview",
    CopyTalentPoolApplicationTemplate: "TalentPoolTemplate/CopyTalentPoolApplicationTemplate",
    ArchiveTalentPoolApplicationTemplate: "TalentPoolTemplate/ArchiveTalentPoolApplicationTemplate",
    SaveTalentApplication: "TalentPoolTemplate/SaveTalentApplication"

  },
  TalentNetwork: {
    GetTalentNetworkListing: "TalentNetwork/GetTalentNetworkListing",
    GetTalentPoolListing: "TalentNetwork/GetTalentPoolListing",
    DeleteTalentPool: "TalentNetwork/DeleteTalentPool",
    GetCandidateIdsByTalentPoolIds: "TalentNetwork/GetCandidateIdsByTalentPoolIds",
    GetCandidateAndTalentPoolsIdsByTalentApplicationIds: "TalentNetwork/GetCandidateAndTalentPoolsIdsByTalentApplicationIds",
    GetCandidateApplications: "TalentNetwork/GetCandidateApplications?CandidateId=",
    GetTalentPoolControlDetail: "TalentNetwork/GetTalentPoolControlDetail?talentPoolId=",
    GetCandidateCV: "TalentNetwork/GetCandidateCV?CandidateId=",
    GetTalentApplicationDetail: "TalentNetwork/GetTalentApplicationDetail",
    GetReceivedEmails: "TalentNetwork/ReceivedEmails",
    GetCandidateNotesWarning: "TalentNetwork/GetCandidateNotesWarning",
    GetSentSMS: "TalentNetwork/GetSentSMS",
  },
  Redeployment: {
    GetCaseListing: "Redeployment/GetCaseListing",
    GetRedeployCandidateDetails: "Redeployment/GetRedeployCandidateDetails",
    GetJobs: "Redeployment/GetJobs",
    AssignToJob: "Redeployment/AssignToJob",
    GetHistory: "Redeployment/GetHistory",
    CheckRedeploymentFormCount: "Redeployment/CheckRedeploymentFormCount",
    SaveTalentApplication: "Redeployment/SaveTalentApplication",
    GetCandidateCv: "Redeployment/GetCandidateCv?CandidateId=",
    GetTalentApplication: "Redeployment/GetTalentApplication",
    GetCandidateDetailsForAssignToUser: "Redeployment/GetCandidateDetailsForAssignToUser?caseIds=",
    GetRedeploymentManagerLookup: "Redeployment/GetRedeploymentManagerLookup",
      AssignToOtherUser: "Redeployment/AssignToOtherUser",
    IsCandidateExist: "Redeployment/IsCandidateExist",
      GetExistingCandidateDetails: "Redeployment/GetExistingCandidateDetails",
      GetStatusesLookup: "Redeployment/GetStatusesLookup",
      GetReasonsLookup: "Redeployment/GetReasonsLookup",
      ChangeCandidateStatus: "Redeployment/ChangeCandidateStatus",
      IsManagerHasViewAllAccess: "Redeployment/IsManagerHasViewAllAccess",
      GetRedeploymentApplicationDetail: "Redeployment/GetRedeploymentApplicationDetail"
  },

  Lookup: {
    GetRecruitmentPhasesLookUp: "LookUp/GetRecruitmentPhasesLookUp",
    GetBanksInfo: "LookUp/GetBanksInfo",
    GetGenders: "LookUp/GetGenders",
    GetCustomFields: "LookUp/GetCustomFields",
    GetLocations: "LookUp/GetSystemLocations",
    GetAgencies: "LookUp/GetAgencies",
    GetAdverts: "LookUp/GetAdvertCategories?pram=",
    GetEmails: "LookUp/GetStandarEmails",
    GetAutoStatus: "LookUp/getAutoStatus",
    GetApplicationStatusLookUp: "GeneralSetup/GetApplicationStatusLookUp",
    GetInitialTest: "LookUp/getInitialTest",
    GetDepartments: "LookUp/GetDepartments",
    getEthicOrgin: "LookUp/getEthicOrgin",
    GetDataFields: "LookUp/GetDataFields",
    GetDivisions: "LookUp/GetDivisions",
    GetCampaigns: "LookUp/GetCampaigns?id=",
    GetLibraryType: "LookUp/GetLibraryTypes",
    GetRegion: "LookUp/GetRegions",
    GetCountry: "LookUp/GetCountry",
    GetRegionalManager: "LookUp/GetRegionalManager",
    GetApplicationTemplates: "LookUp/GetApplicationTemplates",
    GetApplicationStatuses: "LookUp/GetApplicationStatuses",
    GetApplicationStatuses_Server: "LookUp/GetApplicationStatuses_Server",
    GetApplicationStatusesForAgencies: "LookUp/GetApplicationStatusesForAgencies",
    GetSpecialismsForAgencies: "LookUp/GetSpecialismsForAgencies",
    GetJobs: "LookUp/GetJobs",
    GetJobs_Server: "LookUp/GetJobs_Server",
    GetRefereeEmailLookup: "LookUp/GetRefereeEmailLookup",
    GetCandidateJobs_Server: "LookUp/GetCandidateJobs_Server",
    GetTeamManager: "LookUp/GetTeamManagers",
    GetrequisitionUser: "LookUp/GetrequisitionUser",
    GetSystemUser: "Talent/GetSystemUser",
    GetTalentPoolAllLookUp: "Talent/GetTalentPoolAllLookUp",
    GetCategories: "LookUp/GetCategories",
    GetSystemEmployment: "LookUp/GetSystemEmployment",
    GetSalaryBands: "LookUp/GetSalaryBands",
    GetSkillsCategory: "LookUp/GetSkillsCategory",
    GetSkills: "LookUp/GetSkills",
    GetSystemJobStatuses: "LookUp/GetSystemJobStatuses",
    GetSystemUser_Lookup: "LookUp/GetSystemUser_Lookup",
    GetInterviewRooms_Lookup: "LookUp/GetInterviewRooms",
    GetDuration_Lookup: "LookUp/GetDuration",
    GetSystemUser_Lookup_Server: "LookUp/GetSystemUser_Lookup_Server",

    GetAssessment_Lookup: "LookUp/GetAssessment_Lookup",
    GetDocument_Lookup: "LookUp/GetDocument_Lookup",
    GetContract_Lookup: "LookUp/GetContract_Lookup",
    GetGreenRoomTemplates: "LookUp/GetGreenRoomTemplates",
    GetSecurityRoles: "LookUp/GetSecurityRoles",
    GetSecurityRolesLookupServer: "LookUp/GetSecurityRoles_Lookup_Server",
    GetUserActivityLogEventType: "LookUp/GetUserActivityLogEventType_Lookup_Server",
    GetSystemTeams: "LookUp/GetSystemTeams",
    GetSystemLocationsByRegion: "LookUp/GetSystemLocationsByRegion?RegionId=",
    GetAppointmentType_Lookup: "LookUp/GetAppointmentType_Lookup",
    GetAddressBook: "LookUp/GetAddressBook_Lookup",
    GetAllSystemUser: "LookUp/GetAllSystemUser_Lookup",
    GetDocumentLibrary: "LookUp/GetDocumentLibrary_Lookup",
    CalendarDetailsLookUp: "Calendar/CalendarDetailsLookUp",
    GetJobTitles: "LookUp/GetJobTitles",
    GetSchoolLocations: "LookUp/GetSchoolLocations",
    GetBookedStatus: "Calendar/GetBookedStatus",
    GetStatusChangeReasons: "LookUp/GetStatusChangeReasons",
    GetJobAndTemplate: "LookUp/GetJobLockups?pram=",
    GetGBGroupPins: "LookUp/GetGBGroupPins",
    GetSchoolSubject: "LookUp/GetSchoolSubject",
    GetSettingsLookUpData: "LookUp/GetSettingsLookUpData",
    GetSystemAuthUserLookUpData: "SystemSettingLookUp/GetSystemUser",
    GetAuthUserDepartments: "UserManagementLookUp/GetDepartments",
    GetCumSMSLocations: "UserManagementLookUp/GetLocations",
    GetContractDataFields: "SystemSettingLookUp/GetDataField",
    GetDataFieldType: "SystemSettingLookUp/GetDataFieldType",
    GetGBGroupPositions: "LookUp/GetGBGroupPositions",
    GetKypOrgIDs: "LookUp/GetKypOrgIDs",
    GetKypOrgPositions: "LookUp/GetKypOrgPositions?orgShortCode=",
  },
  UserManagementLookup: {
    GetDepartments: "UserManagementLookUp/GetDepartments",
    GetSecurityRoles: "UserManagementLookUp/GetSecurityRoles",
    GetApplicationStatus: "UserManagementLookUp/GetApplicationStatus",
    GetSystemUser: "UserManagementLookUp/GetSystemUser",
    GetSystemUser_Lookup_Server: "UserManagementLookUp/GetSystemUser_Lookup_Server"
  },
  SystemSettingLookup: {
    GetSystemTeams_Lookup: "SystemSettingLookUp/GetSystemTeams_Lookup",
    GetLocations: "SystemSettingLookUp/GetLocations",
    GetDepartments: "SystemSettingLookUp/GetDepartments",
    GetRegions: "SystemSettingLookUp/GetRegions",
    GetSystemUser: "SystemSettingLookUp/GetSystemUser",
    GetApplicationStatus: "SystemSettingLookup/GetApplicationStatus",
    GetRequisitionUser: "SystemSettingLookup/GetRequisitionUser",
    GetAuthorisationGroup: "SystemSettingLookup/GetAuthorisationGroup",
    GetDefaultApprovalCategories: "SystemSettingLookup/GetDefaultApprovalCategories",
    GetSystemPipeLine: "SystemSettingLookUp/GetSystemPipeLine",
    GetDataField: "SystemSettingLookUp/GetDataField",
    GetTextRepository: "SystemSettingLookUp/GetTextRepository",
    GetReferees: "SystemSettingLookUp/GetReferees",
    // GetApplicationStatus: "SystemSettingLookUp/GetApplicationStatus",
    GetTalentPools: "SystemSettingLookUp/GetTalentPools",
    GetCandidateTalentPools: "SystemSettingLookUp/GetCandidateTalentPools",
    GetStandardEmails: "SystemSettingLookUp/GetStandardEmails",
    GetStandardSms: "SystemSettingLookUp/GetStandardSms",
    GetStandardLetters: "SystemSettingLookUp/GetStandardLetters",
    GetContracts: "SystemSettingLookUp/GetContracts",
    GetAdminForm: "SystemSettingLookUp/GetAdminForm",
    GetStandarEmails_Lookup: "SystemSettingLookUp/GetStandarEmails_Lookup",
    GetSystemLocationsByRegion: "SystemSettingLookUp/GetSystemLocationsByRegion",
    GetRegion: "SystemSettingLookUp/GetRegion",
    GetSystemJobStatuses: "SystemSettingLookUp/GetSystemJobStatuses",
    GetHiringManagers: "SystemSettingLookUp/GetHiringManagers",
    GetAddressBook: "SystemSettingLookUp/GetAddressBook",
    // GetSystemJobStatuses: "SystemSettingLookUp/GetSystemJobStatuses",
    GetDivisions: "SystemSettingLookup/GetDivisions",
    GetPipelines: "SystemSettingLookup/GetPipelines",
    GetReedAccounts: "SystemSettingLookup/GetReedAccounts",
    GetTotalJobsAccounts: "SystemSettingLookup/GetTotalJobsAccounts",
    //GetAddressBook: "SystemSettingLookUp/GetAddressBook",
    GetLibraryTypeCompliance: "LookUp/GetLibraryTypesCompliance",
    GetSchoolSubject: "SystemSettingLookup/GetSchoolSubject",
    GetKypOrgIDs: "SystemSettingLookUp/GetKypOrgIDs",
    GetGBGroupPositions: "SystemSettingLookup/GetKypPositions",
    GetCountry: "SystemSettingLookup/GetCountry",
    GetReasonForVacancy: "SystemSettingLookup/GetReasonForVacancy",
    GetFundingSource: "SystemSettingLookup/GetFundingSource",
    GetSchoolLocations: "Search/GetSchoolLocations",

  },
  OnboardingLookup: {
    GetTemplates: "OnboardingLookUp/GetTemplates",
    GetDepartments: "OnboardingLookUp/GetDepartments",
    GetLocations: "OnboardingLookUp/GetLocations",
    GetDivisions: "OnboardingLookUp/GetDivisions"
  },
  JobsAndTalentLookup: {
    GetRequisitionScheme: "JobsAndTalentLookUp/GetRequisitionScheme",
    GetAdminReferenceForm: "JobsAndTalentLookUp/GetAdminReferenceForm",

    GetRegions: "JobsAndTalentLookUp/GetRegions",
    GetTalentPoolLookup: "JobsAndTalentLookUp/GetTalentPoolLookup",
    GetLocations: "JobsAndTalentLookUp/GetLocations",
    GetStandardEmails: "JobsAndTalentLookUp/GetStandardEmails",
    GetDocumentLibrary: "JobsAndTalentLookUp/GetDocumentLibrary",
    GetApplicationStatus: "JobsAndTalentLookUp/GetApplicationStatus",
    GetJobTemplates: "JobsAndTalentLookUp/GetJobTemplates",
    GetJobRegions: "JobsAndTalentLookUp/GetJobRegions",
    GetLookUpDataForCCL: "JobsAndTalentLookUp/GetLookUpDataForCCL",
    GetSpeciality: "SystemSettingLookUp/GetSpeciality",
    GetReasonsList: "JobsAndTalentLookUp/GetReasonsList",
    GetCandidateReference: "JobsAndTalentLookUp/GetCandidateReference",
    GetRedeploymentFormLookup: "JobsAndTalentLookUp/GetRedeploymentFormLookup",
  },
  ESRIntegrationLookup: {
    GetESRCostCentre: "ESR/GetESRCostCentre",
    GetESRPositionsByCostCenter: "ESR/GetESRPositionsByCostCenter",
    GetESRPositionsDetails: "ESR/GetESRPositionDetails",

  },
  CandidateDetailLookup: {
    GetLocations: "CandidateDetailLookUp/GetLocations",
    GetSpecialities: "CandidateDetailLookUp/GetSpecialities",
  },
  ReportingLookup: {
    GetDepartments: "ReportingLookup/GetDepartments",
    GetLocations: "ReportingLookup/GetLocations",
    GetApplicationStatus: "ReportingLookup/GetApplicationStatus",
    GetSystemEmployment: "ReportingLookup/GetSystemEmployment",
    GetJobLevels: "ReportingLookup/GetJobLevels",
    GetSystemJobStatuses: "ReportingLookup/GetSystemJobStatuses",
    GetRegions: "ReportingLookup/GetRegions",
    GetAgencies: "ReportingLookup/GetAgencies",
    GetAdvert: "ReportingLookup/GetAdvert",
    GetGender: "ReportingLookup/GetGender",
    GetAdvertCategories: "ReportingLookup/GetAdvertCategories", 
    GetReligious: "ReportingLookup/GetReligious",
    GetAssessmentForm: "ReportingLookup/GetAssessmentForm",
    GetJobs: "ReportingLookup/GetJobs",
    GetSystemUser_Lookup_Server: "LookUp/GetSystemUser_Lookup_Server",
    GetDivision: "ReportingLookup/GetDivision",
    Ob_GetDocuments: "ReportingLookup/GetOnboardingDocumentLookup",
    Ob_GetForms: "ReportingLookup/GetOnboardingFormLookup",
    SystemUsers: "ReportingLookup/GetSystemUserLookup",
    ComplianceDocument: "ReportingLookup/GetComplianceDocumentLookup",
    GetComplianceForms: "ReportingLookup/GetComplianceFormLookup",
    GetCampaigns: "ReportingLookup/GetCampaigns",
    GetSchoolLocationLookup: "ReportingLookup/GetSchoolLocationLookup",
    GetCategories: "ReportingLookup/GetCategories",
    GetSkills: "ReportingLookup/GetSkills",
  },
  CalendarLookup: {
    GetAppointmentType_Lookup: "CalendarLookUp/GetAppointmentType_Lookup",
    GetDocumentLibrary: "CalendarLookUp/GetDocumentLibrary",
    GetSystemLocationsByRegion: "CalendarLookUp/GetSystemLocationsByRegion",
    GetCampaigns: "CalendarLookUp/GetCampaigns"
  },
  GeneralSetupLookup: {
    GetLookUpData: "GeneralSetup/GetLookUpData",
    GetCampaigns: "GeneralSetupLookUp/GetCampaigns",
    GetAddressBook_Lookup: "GeneralSetupLookUp/GetAddressBook_Lookup",
    GetAllSystemUser_Lookup: "GeneralSetupLookUp/GetAllSystemUser_Lookup",
    GetSpecialisms: "GeneralSetupLookUp/GetSpecialisms_LookUp",
    GetNHSStaffGroupLookUp: "GeneralSetupLookUp/GetNHSStaffGroupLookUp"
  },

  GeneralSettings: {

    GetJobAndCandidateStatuses: "JobStatusAutomation/GetJobAndCandidateStatuses",
    GetJobAutomationStages: "JobStatusAutomation/GetJobAutomationStages",
    SaveAutomationStages: "JobStatusAutomation/SaveAutomationStages",
    DeleteAutomationStage: "JobStatusAutomation/DeleteAutomationStage?id=",


    GetJobLookUp: "GeneralSetup/GetLookUpData",
    Tiles: "Settings/GeneralSettings",
    GetListing: "GeneralSetup/GetListing",
    Save: "GeneralSetup/Save",
    SaveTranslation: "GeneralSetup/SaveTranslation?controllerName=",
    GetById: "GeneralSetup/GetById?id=",
    GetApplicationsStatusById: "GeneralSetup/GetApplicationsStatusById?id=",
    Archived: "GeneralSetup/Archived",
    NameParams: "&controllerName=",
    GetForTranslation: "GeneralSetup/GetForTranslation?id=",
    GetTranlationCount: "GeneralSetup/GetTranlationCount?controllerName=",
    ShowAgency: "GeneralSetup/ShowAgency?id=",

    GetJobRegionListing: "GeneralSetup/GetJobRegionListing",
    JobRegionSave: "GeneralSetup/JobRegionSave",
    GetJobRegionById: "GeneralSetup/GetJobRegionById?id=",
    JobRegionArchived: "GeneralSetup/JobRegionArchived",
    GetJobTitlesListing: "GeneralSetup/GetJobTitlesListing",
    JobTitlesSave: "GeneralSetup/JobTitlesSave",
    GetJobTitlesById: "GeneralSetup/GetJobTitlesById?id=",
    JobTitlesArchived: "GeneralSetup/JobTitlesArchived",
    GetLocationListing: "GeneralSetup/GetLocationListing",
    LocationSave: "GeneralSetup/LocationSave",
    GetLocationById: "GeneralSetup/GetLocationById?id=",
    LocationArchived: "GeneralSetup/LocationArchived",
    GetLatitudeLongLongitude: "GeneralSetup/GetLatitudeLongLongitude?postCode=",

    GetPackageListing: "GeneralSetup/GetPackageListing",
    PackageSave: "GeneralSetup/PackageSave",
    GetPackageById: "GeneralSetup/GetPackageById?id=",
    PackageArchived: "GeneralSetup/PackageArchived",
    GetSalaryBandListing: "GeneralSetup/GetSalaryBandListing",
    SalaryBandSave: "GeneralSetup/SalaryBandSave",
    GetSalaryBandById: "GeneralSetup/GetSalaryBandById?id=",
    SalaryBandArchived: "GeneralSetup/SalaryBandArchived",
    GetSchoolLocationListing: "GeneralSetup/GetSchoolLocationListing",
    SchoolLocationSave: "GeneralSetup/SchoolLocationSave",
    GetSchoolLocationById: "GeneralSetup/GetSchoolLocationById?id=",
    SchoolLocationArchived: "GeneralSetup/SchoolLocationArchived",
    GetSchoolSubjectListing: "GeneralSetup/GetSchoolSubjectListing",
    SchoolSubjectSave: "GeneralSetup/SchoolSubjectSave",

    GetSchoolSubjectById: "GeneralSetup/GetSchoolSubjectById?id=",
    SchoolSubjectArchived: "GeneralSetup/SchoolSubjectArchived",
    GetStatusChangeReasonListing: "GeneralSetup/GetStatusChangeReasonListing",
    StatusChangeReasonSave: "GeneralSetup/StatusChangeReasonSave",
    GetStatusChangeReasonById: "GeneralSetup/GetStatusChangeReasonById?id=",
    StatusChangeReasonArchived: "GeneralSetup/StatusChangeReasonArchived",
    GetWorkLevelListing: "GeneralSetup/GetWorkLevelListing",
    WorkLevelSave: "GeneralSetup/WorkLevelSave",
    GetWorkLevelById: "GeneralSetup/GetWorkLevelById?id=",
    WorkLevelArchived: "GeneralSetup/WorkLevelArchived",
    GetJobLevelListing: "GeneralSetup/GetJobLevelListing",
    JobLevelSave: "GeneralSetup/JobLevelSave",
    GetJobLevelById: "GeneralSetup/GetJobLevelById?id=",
    JobLevelArchived: "GeneralSetup/JobLevelArchived",
    GetJobCodeListing: "GeneralSetup/GetJobCodeListing",
    JobCodeSave: "GeneralSetup/JobCodeSave",
    GetJobCodeById: "GeneralSetup/GetJobCodeById?id=",
    JobCodeArchived: "GeneralSetup/JobCodeArchived",
    GetJobCategoryListing: "GeneralSetup/GetJobCategoryListing",
    JobCategorySave: "GeneralSetup/JobCategorySave",
    GetJobCategoryById: "GeneralSetup/GetJobCategoryById?id=",
    JobCategoryArchived: "GeneralSetup/JobCategoryArchived",
    GetGBGroupPinListing: "GeneralSetup/GetGBGroupPinListing",
    GBGroupPinSave: "GeneralSetup/GBGroupPinSave",
    GetGBGroupPinById: "GeneralSetup/GetGBGroupPinById?id=",
    GBGroupPinArchived: "GeneralSetup/GBGroupPinArchived",
    GetEthnicOriginListing: "GeneralSetup/GetEthnicOriginListing",
    EthnicOriginSave: "GeneralSetup/EthnicOriginSave",
    GetEthnicOriginById: "GeneralSetup/GetEthnicOriginById?id=",
    EthnicOriginArchived: "GeneralSetup/EthnicOriginArchived",
    GetDocumentLibraryListing: "GeneralSetup/GetDocumentLibrariesList",
    DocumentLibrarySave: "GeneralSetup/DocumentLibrarySave",
    GetDocumentLibraryById: "GeneralSetup/GetDocumentLibraryById?id=",
    DocumentLibraryArchived: "GeneralSetup/DocumentLibraryArchived",
    DocumentLibraryCopyUrl: "GeneralSetup/DocumentLibraryCopyUrl",
    GetDivisionListing: "GeneralSetup/GetDivisionListing",
    DivisionSave: "GeneralSetup/DivisionSave",
    GetDivisionById: "GeneralSetup/GetDivisionById?id=",
    DivisionArchived: "GeneralSetup/DivisionArchived",
    GetDepartmentListing: "GeneralSetup/GetDepartmentListing",
    DepartmentSave: "GeneralSetup/DepartmentSave",
    GetDepartmentById: "GeneralSetup/GetDepartmentById?id=",
    DepartmentArchived: "GeneralSetup/DepartmentArchived",
    GetCostCentreListing: "GeneralSetup/GetCostCentreListing",
    GetCostCentreListForDropDown: "GeneralSetup/GetCostCentreListingForDropDown",
    GetBoardPositionListingForDropDown: "GeneralSetup/GetBoardPositionListingForDropDown",
    CostCentreSave: "GeneralSetup/CostCentreSave",
    GetCostCentreById: "GeneralSetup/GetCostCentreById?id=",
    CostCentreArchived: "GeneralSetup/CostCentreArchived",
    GetCandidateApplicationStatusListing: "GeneralSetup/GetCandidateApplicationStatusListing",
    CandidateApplicationStatusSave: "GeneralSetup/CandidateApplicationStatusSave",
    CandidateApplicationStatusArchived: "GeneralSetup/CandidateApplicationStatusArchived",
    GetCampaignListing: "GeneralSetup/GetCampaignListing",
    CampaignSave: "GeneralSetup/CampaignSave",
    GetCampaignById: "GeneralSetup/GetCampaignById?id=",
    CampaignArchived: "GeneralSetup/CampaignArchived",
    GetAgencyListing: "GeneralSetup/GetAgencyListing",
    AgencySave: "GeneralSetup/AgencySave",
    AgencyUserSave: "GeneralSetup/AgencyUserSave",
    DeleteAgencyUser: "GeneralSetup/DeleteAgencyUser",


    GetAgencyById: "GeneralSetup/GetAgencyById?id=",
    GetAgencyAttachmentById: "GeneralSetup/GetAgencyAttachmentById?id=",
    ArchiveAgency: "GeneralSetup/ArchiveAgency",
    GetAdvertListing: "GeneralSetup/GetAdvertListing",
    AdvertSave: "GeneralSetup/AdvertSave",
    GetAdvertById: "GeneralSetup/GetAdvertById?id=",
    AdvertArchived: "GeneralSetup/AdvertArchived",
    GetAdvertCategoryListing: "GeneralSetup/GetAdvertCategoryListing",
    AdvertCategorySave: "GeneralSetup/AdvertCategorySave",
    GetAdvertCategoryById: "GeneralSetup/GetAdvertCategoryById?id=",
    AdvertCategoryArchived: "GeneralSetup/AdvertCategoryArchived",
    GetAllAdverts: "GeneralSetup/GetAllAdverts?controllerName=",

    GetAddressBookListing: "GeneralSetup/GetAddressBookListing",
    AddressBookSave: "GeneralSetup/AddressBookSave",
    UpdateApplicatonStatusVisibility: "GeneralSetup/UpdateApplicatonStatusVisibility",
    GetAddressBookById: "GeneralSetup/GetAddressBookById?id=",
    AddressBookArchived: "GeneralSetup/AddressBookArchived",
    SkillCategorySave: "GeneralSetup/SkillCategorySave",
    GetSkillCategoryById: "GeneralSetup/GetSkillCategoryById?id=",
    SpecialismSave: "GeneralSetup/SaveSpecialisms",
    GetSpecialismById: "GeneralSetup/GetSpecialismById?id=",
    SpecialismArchived: "GeneralSetup/SpecialismArchived",
    GetSpecialismsListing: "GeneralSetup/GetSpecialismsListing",
    GetLogosListing: "GeneralSetup/GetLogosListing",
    GetLogoById: "GeneralSetup/GetLogoById?id=",
    SaveLogos: "GeneralSetup/SaveLogos",
    SkillCategoryArchived: "GeneralSetup/SkillCategoryArchived",
    GetSkillCategoryListing: "GeneralSetup/GetSkillCategoryListing",
    SkillSave: "GeneralSetup/SkillSave",
    GetSkillById: "GeneralSetup/GetSkillById?id=",
    SkillArchived: "GeneralSetup/SkillArchived",
    GetSkillListing: "GeneralSetup/GetSkillListing",

    GetJobTemplatesListing: "GeneralSetup/GetJobTemplatesListing",
    GetJobTemplateById: "GeneralSetup/GetJobTemplateById?id=",
    CreateJobTemplatesListing: "GeneralSetup/CreateJobTemplates",
    JobTemplateDelete: "GeneralSetup/JobTemplateArchived",
    JobTemplateSave: "GeneralSetup/JobTemplateSave",

    GetAccountCodesListing: "GeneralSetup/GetAccountCodesListing",
    GetNHSbanksListing: "GeneralSetup/GetNHSbanksListing",
    GetNHSJKLBand: "GeneralSetup/GetJKLBand",
    GetAvailabilitySupplement: "GeneralSetup/GetAvailabilitySupplement",
    GetAccountCodeById: "GeneralSetup/GetAccountCodeById?id=",
    GetBankById: "GeneralSetup/GetBankById?id=",
    GetJKLBandById: "GeneralSetup/GetJKLBandById?id=",
    GetAvailabilitySupplementById: "GeneralSetup/GetAvailabilitySupplementById?id=",
    GetSpecialtyById: "GeneralSetup/GetSpecialtyById?id=",
    CreateAccountCodesListing: "GeneralSetup/CreateAccountCodesListing",
    CreateNHSBanksListing: "GeneralSetup/CreateNHSBanksListing",
    SaveJKLBand: "GeneralSetup/SaveJKLBand",
    SaveAvailabilitySupplement: "GeneralSetup/SaveAvailabilitySupplement",
    SaveParseAccounts: "GeneralSetup/SaveParseAccounts",
    AccountCodeDelete: "GeneralSetup/AccountCodeArchived",
    NHSBankDelete: "GeneralSetup/NHSBankArchived",
    JKLBandDelete: "GeneralSetup/JKLBandArchived",
    AvailabilitySupplementDelete: "GeneralSetup/AvailabilitySupplementArchived",
    StaffGroupDelete: "GeneralSetup/StaffGroupArchived",
    SpecialtyArchived: "GeneralSetup/SpecialtyArchived",
    GetSpecialtiesListing: "GeneralSetup/GetSpecialtiesListing",
    SaveSpecialties: "GeneralSetup/SaveSpecialties",
    GetCostCodesListing: "GeneralSetup/GetCostCodesListing",
    GetApplicationStatuses: "GeneralSetup/GetApplicationStatuses",
    GetCostCodesById: "GeneralSetup/GetCostCodeById?id=",
    CreateCostCodesListing: "GeneralSetup/CreateCostCodesListing",
    CostCodesDelete: "GeneralSetup/CostCodeArchived",

    GetBoardPositionListing: "GeneralSetup/GetBoardPositionListing",
    GetBoardPositionById: "GeneralSetup/GetBoardPositionById?id=",
    CreateBoardPositionListing: "GeneralSetup/CreateBoardPositionListing",
    BoardPositionDelete: "GeneralSetup/BoardPositionArchived",
    SaveParseBoard: "GeneralSetup/SaveParseBoard",
    SaveParseCost: "GeneralSetup/SaveParseCost",
    GetStatusGroup_Lookup_Server: "GeneralSetup/GetStatusGroup_Lookup_Server",

    GetDelAndAppWithdrawReasonsListing: "GeneralSetup/GetDelWithdrawReasonsListing",
    DelAndAppWithdrawReasonSave: "GeneralSetup/DelWithdrawReasonsSave",
    DelAndAppWithdrawReasonsArchived: "GeneralSetup/DelWithdrawReasonArchived",
    GetDelAndAppWithdrawReasonById: "GeneralSetup/GetDelAndAppWithdrawReasonById?id=",

    GetStaffGroupsListing: "GeneralSetup/GetStaffGroupsListing",
    CreateStaffGroupsListing: "GeneralSetup/CreateStaffGroupsListing",
    GetStaffGroupById: "GeneralSetup/GetStaffGroupById?id=",
    SaveParseStaffGroups: "GeneralSetup/SaveParseStaffGroups",

    GetJobDescriptionsListing: "GeneralSetup/GetJobDescriptionsListing",
    JobDescriptionsArchived: "GeneralSetup/JobDescriptionArchived",
    CreateJobDescriptionsListing: "GeneralSetup/CreateJobDescriptionsListing",
    GetJobDescriptionsById: "GeneralSetup/GetJobDescriptionsById?id=",
    GetJobGroupListForDropDown: "GeneralSetup/GetJobGroupListForDropDown",
    SaveParseJobDescription: "GeneralSetup/SaveParseJobDescription",

    GetWithdrawReasonsListing: "RedeploymentWithdrawReason/GetListing",
    SaveWithdrawReason: "RedeploymentWithdrawReason/Save",
    ArchivedWithdrawReasons: "RedeploymentWithdrawReason/Archived",
    GetReasonById: "RedeploymentWithdrawReason/GetById?id=",



    GetGbgKypShortCodesListing: "GeneralSetup/GetGbgKypShortCodeListing",
    GbgKypShortCodesSave: "GeneralSetup/GbgKypShortCodeSave",
    GbgKypShortCodesArchived: "GeneralSetup/GbgKypShortCodeArchived",
    GetGbgKypShortCodesById: "GeneralSetup/GetGbgKypShortCodeById?id=",
    SavePosition: "GeneralSetup/SavePosition",
    GetPositions: "GeneralSetup/GetPositions",
    GetPositionById: "GeneralSetup/GetPositionById?id=",
    PositionDelete: "GeneralSetup/ArchivePosition",
    BulkUploadPositions: "GeneralSetup/BulkUploadPositions",

    SaveColleagueCategories: "GeneralSetup/SaveColleagueCategories",
    GetColleagueCategories: "GeneralSetup/GetColleagueCategories",
    GetColleagueCategoryById: "GeneralSetup/GetColleagueCategoryById?id=",
    DeleteColleagueCategory: "GeneralSetup/DeleteColleagueCategory",
    BulkUploadColleagueCategories: "GeneralSetup/BulkUploadColleagueCategories",
    UpdateApplicationStatusesDisplayOrder: "GeneralSetup/UpdateApplicationStatusesDisplayOrder",


    SaveWorkPattern: "GeneralSetup/SaveWorkPattern",
    GetWorkPatterns: "GeneralSetup/GetWorkPatterns",
    GetWorkPatternsId: "GeneralSetup/GetWorkPatternsId?id=",
    WorkPatternsDelete: "GeneralSetup/ArchiveWorkPatterns",
    BulkUploadWorkPatterns: "GeneralSetup/BulkUploadWorkPatterns",


    SavePostReference: "GeneralSetup/SavePostReference",
    GetPostReference: "GeneralSetup/GetPostReference",
    DeletePostReference: "GeneralSetup/ArchivePostReference",
    GetPostReferenceById: "GeneralSetup/GetPostReferenceById?id=",
    BulkUploadPostReference: "GeneralSetup/BulkUploadPostReference",

    FundingSourceSave: "FundingSource/Save",
    GetFundingSourceById: "FundingSource/GetById?id=",
    GetFundingSourceListing: "FundingSource/GetListing",
    FundingSourceArchived: "FundingSource/Archived",

    MarketPlace: {
      GetCampaingnsListing: "MarketPlace/GetCampaingnsListing",
      GetCampaingnDetailListing: "MarketPlace/GetCampaingnDetailListing",
      GetCampaignDetailById: "MarketPlace/GetCampaignDetailById?id=",
      GetJobTitleById: "MarketPlace/GetJobTitleById?id=",
      CloseCampaignById: "MarketPlace/CloseCampaignById?id=",
    },
  },
  Calendar: {
    GetListing: "Calendar/GetListing",
    GetCalendarLookup: "Calendar/GetCalendarLookup",
    Save: "Calendar/Save",
    Update: "Calendar/Update",
    Upload: "Calendar/Upload",
    GetAllById: "Calendar/GetAllById?id=",
    GetById: "Calendar/GetById?id=",
    Archived: "Calendar/Archived",
    UnArchive: "Calendar/UnArchive",
    Copy: "Calendar/Copy",
    NameParams: "&controllerName=",
    GetDetailTabById: "Calendar/CalendarDetails?id=",
    GetUserId: "Calendar/GetUser",
    GetBookedCandidate: "Calendar/GetBookedCandidate?id=",
    GetAppointments: "Calendar/GetAppointments",
    Vacant: "Calendar/GetVacantSlots?id=",
    GetAppointmentsCount: "Calendar/GetAppointmentsCDCount",
    DeleteAttachment: "Calendar/RemoveAttachment",
    PreviewAttachment: "Calendar/PreviewAttachment",
    ArchiveAppointment: "Calendar/ArchiveAppointment"

  },
  AlertSetup: {
    NameParams: "&controllerName=",
    Tiles: "Settings/GeneralSettings",
    GetAlertSetupListing: "AlertSetup/GetAlertSetupListing",
    GetSavedAlertSetupListing: "AlertSetup/GetSavedAlertSetupListing",
    GetCandidateAlertListing: "AlertSetup/GetCandidateAlertListing",
    SaveMyCandidateAlert: "AlertSetup/SaveMyCandidateAlert",
    GetCandidateAlertById: "AlertSetup/GetCandidateAlertById?id=",
    DeleteCandidateAlert: "AlertSetup/DeleteCandidateAlert",
    GetDataCandidateAlrets: "AlertSetup/GetDataCandidateAlrets",



    GetTextMessageListing: "AlertSetup/GetTextMessageListing",
    GetMyEmailListing: "AlertSetup/GetMyEmailListing",

    ArchivedSystemAlert: "AlertSetup/ArchivedSystemAlert",
    SaveSystemAlert: "AlertSetup/SaveSystemAlert",
    GetSystemAlertById: "AlertSetup/GetSystemAlertById?id=",
    GetSystemAlertModelById: "AlertSetup/GetSystemAlertDetailById?id=",
    SaveSystemAlertDetail: "AlertSetup/SaveSystemAlertDetail",
    ArchivedSystemAlertDetail: "AlertSetup/ArchivedSystemAlertDetail?id=",

    GetMyCandidateAlert: "AlertSetup/GetMyCandidateAlert",
    GetSelectedDocTextValue: "AlertSetup/GetSelectedDocTextValue?documentIds=",


  },
  EmailOptions: {
    GetListing: "Communication/GetEmailTemplates",
    GetEmailTemplateById: "Communication/GetEmailTemplateById?emailTemplateId=",
    Archive: "Communication/ArchiveEmailTemplates",
    CreateGet: "Communication/GetEmailTemplate/",
    CreateSave: "Communication/SaveEmailTemplate/",
    GetStandardEmails: "Communication/GetStandardEmails",
    CopyEmailTemplate: "Communication/CopyEmailTemplate"
  },
  EmailInbox: {
    GetEmailInboxList: "Communication/GetEmailInboxList",
    EmailInboxMarkAsRead: "Communication/EmailInboxMarkAsRead",
    EmailInboxMarkAsUnRead: "Communication/EmailInboxMarkAsUnRead",
    ArchiveEmailInbox: "Communication/ArchiveEmailInbox",
    GetEmailInbox: "Communication/GetEmailInbox/",
    GetCandidateEmailView: "Communication/GetCandidateEmailView/",
    ForwardEmailInbox: "Communication/ForwardEmailInbox",
    ReplyEmailInbox: "Communication/ReplyEmailInbox",
  },
  LetterOptions: {
    GetListing: "Communication/GetLetterTemplates",
    Archive: "Communication/ArchiveLetterTemplates",
    CreateGet: "Communication/GetLetterTemplate/",
    CreateSave: "Communication/SaveLetterTemplate/",
  },
  Contracts: {
    GetListing: "Communication/GetContractsList",
    Archive: "Communication/ArchiveContracts",
    CreateGet: "Communication/GetContract/",
    CreateSave: "Communication/SaveContract/",
  },
  ContractImages: {
    GetListing: "ContractImages/GetListing",
    GetById: "ContractImages/GetById?id=",
    Save: "ContractImages/Save",
    Archived: "ContractImages/Archived",
  },
  ContractSection: {
    GetListing: "Communication/GetContractSectionsList",
    Archive: "Communication/ArchiveContractSections",
    CreateGet: "Communication/GetContractSection/",
    CreateSave: "Communication/SaveContractSection/",
    GetTextRepositoryList: "Communication/GetTextRepositoryList/",
    GetTextRepositories: "Communication/GetTextRepositories/",
  },
  EmailOutbox: {
    GetEmailOutboxList: "Communication/GetEmailOutboxList",
    GetEmailOutbox: "Communication/GetEmailOutbox?Id=",
    GetEmailOutboxById: "Communication/GetEmailOutbox",
    DownloadEmailAttachmentById: "Communication/DownloadEmailAttachmentById?Id=",
    ForwardEmailOutbox: "Communication/ForwardEmailOutbox",
    ForwardCandidateEmail: "Communication/ForwardCandidateEmail",
    ReSendEmail: "Communication/ReSendEmail",
    GetOutboxById: "Communication/GetOutboxById?Id=",
  },
  SmsOptions: {
    GetSmsTemplates: "Communication/GetSmsTemplates",
    GetSmsTemplate: "Communication/GetSmsTemplate/",
    SaveSmsTemplate: "Communication/SaveSmsTemplate",
    ArchiveSmsTemplate: "Communication/ArchiveSmsTemplate",
    GetStandardSms: "Communication/GetStandardSms"
  },
  SmsOutbox: {
    GetSmsDetail: "Communication/GetSmsDetail",
    GetInboxSmsDetail: "Communication/GetInboxSmsDetail"
  },
  Search: {
    GetSearchFiltersData: "Search/GetSearchFiltersData",
    GetCandidateSearchList: "Search/GetCandidateSearchList",
    GetSearchCandidateFiltersData: "Search/GetSearchCandidateFiltersData",
    GetSearchTalentFiltersData: "Search/GetSearchTalentFiltersData",
    GetSearchKeywordFiltersData: "Search/GetSearchKeywordFiltersData",
    GetJobAlertList: "Search/GetJobAlertList",
    SaveCandidateAlerts: "Search/SaveCandidateAlerts",
    GetApplicationSearchTemplates: "search/GetApplicationSearchTemplates?ApplicationTemplateId=",
    GetAdditionalFiltersData: "search/GetAdditionalFiltersData",
    GetSearchJobsFilterData: "search/GetSearchJobsFilterData",
    GetJobsSearchList: "Search/GetJobsSearchList",
    GetJobsSearchHMList: "SearchHM/GetJobsSearchList",
    GetAddressBook: "Search/GetAddressBook",
    GetDocumentLibrary: "Search/GetDocumentLibrary",
    GetNylasConfigurationEmails: "Search/GetNylasConfigurationEmails",
    GetCandidateApplicationDocuments: "Search/GetCandidateApplicationDocuments",
    GetApplicationSearchList: "Search/GetApplicationSearchList",
    GetSearchCriteriaList: "Search/GetSearchCriteriaList?SavedSearchId=",
    GetSavedCandidateSearchList: "Search/GetSavedCandidateSearchList?SavedSearchId=",
    RemoveSavedSearchCandidate: "Search/RemoveSavedSearchCandidate",
    GetTalentSearchList: "Search/GetTalentSearchList",
    GetKeywordSearchList: "Search/GetKeywordSearchList",
    GetAddressBookSearchList: "Search/GetAddressBookSearchList",
    GetJobLookUp: "Search/GetLookUpData",
    GetDivisionsBySchoolLocations: "Search/GetDivisionsBySchoolLocations/",
    GetJobAlertsSessionVariables: "Search/GetJobAlertsSessionVariables",

  },
  eEss: {
    GeteEssFormData: "Integration/GeteEssFormData",
    DownloadPdfFile: "Integration/DownloadPdfFile",
    GetTransactionLogs: "Integration/GetTransactionLogs",
    GetnhsCostCodes: "Integration/GetnhsCostCodes",
    SaveeEssForm: "Integration/SaveeEssForm",
    GetAccountCodeData: "Integration/GetNHSAccountCodes_Server",
    GetCostCenterData: "Integration/GetNHSCostCodes_Server",
    GetBoardPositionData: "Integration/GetNHSBoardPositions_Server",

    GetContractTypes: "Integration/GetContractTypes",
    GetAccrualPlans: "Integration/GetAccrualPlans",
    GetAssignmentCategories: "Integration/GetAssignmentCategories",

    GetStaffGroupData: "Integration/GetNHSStaffGroups_Server",
    GetJobDescriptionData: "Integration/GetNHSJobDescriptions_Server",
    GetJKLBandData: "Integration/GetNHSJKLBands_Server",
    GetAvailabilitySupplementData: "Integration/GetNHSAvailabilitySupplements_Server",
    GetMedicalAndDentalEffectiveDateReferToData: "Integration/GetNHSMedicalAndDentalEffectiveDateReferTos_Server",
    GetNHSmicsReasonsData: "Integration/GetNHSmicsReasons_Server",
  },
  eEss2nd: {
    GeteEssFormData: "eEss2nd/GeteEssFormData",
    DownloadPdfFile: "eEss2nd/DownloadPdfFile",
    GetTransactionLogs: "eEss2nd/GetTransactionLogs",
    GetnhsCostCodes: "eEss2nd/GetnhsCostCodes",
    SaveeEssForm: "eEss2nd/SaveeEssForm",
    GetAccountCodeData: "eEss2nd/GetNHSAccountCodes_Server",
    GetCostCenterData: "eEss2nd/GetNHSCostCodes_Server",
    GetBoardPositionData: "eEss2nd/GetNHSBoardPositions_Server",

    GetStaffGroupData: "eEss2nd/GetNHSStaffGroups_Server",
    GetJobDescriptionData: "eEss2nd/GetNHSJobDescriptions_Server",
    GetJKLBandData: "eEss2nd/GetNHSJKLBands_Server",
    GetAvailabilitySupplementData: "eEss2nd/GetNHSAvailabilitySupplements_Server",
    GetMedicalAndDentalEffectiveDateReferToData: "eEss2nd/GetNHSMedicalAndDentalEffectiveDateReferTos_Server",
    GetNHSmicsReasonsData: "eEss2nd/GetNHSmicsReasons_Server",
  },
  fileuploadLog: {
    GetFileuploadLogs: "iTrentPriory/GetFileuploadLogs",
  },
  Nylas: {
    GetPersonalInbox: "NylasIntegration/GetPersonalInbox",
    GetCorporateInbox: "NylasIntegration/GetCorporateInbox",
    GetPersonalEmailByIds: "NylasIntegration/GetPersonalEmailByIds",
    GetCorporateEmailByIds: "NylasIntegration/GetCorporateEmailByIds",
    IsPersonalEmailExistInApplication: "NylasIntegration/IsPersonalEmailExistInApplication",
    IsCorporateEmailExistInApplication: "NylasIntegration/IsCorporateEmailExistInApplication",
    GetPersonalEmailAttachmentsByMessageId: "NylasIntegration/GetPersonalEmailAttachmentsByMessageId",
    GetCorporateEmailAttachmentsByMessageId: "NylasIntegration/GetCorporateEmailAttachmentsByMessageId",
    GetPersonalCandidateApplications: "NylasIntegration/GetPersonalCandidateApplications",
    GetCorporateCandidateApplications: "NylasIntegration/GetCorporateCandidateApplications",
    MarkReadUnreadPersonalEmails: "NylasIntegration/MarkReadUnreadPersonalEmails",
    MarkReadUnreadCorporateEmails: "NylasIntegration/MarkReadUnreadCorporateEmails",
    ConvertToCandidateThroughPersonalAccount: "NylasIntegration/ConvertToCandidateThroughPersonalAccount",
    ConvertToCandidateThroughCorporateAccount: "NylasIntegration/ConvertToCandidateThroughCorporateAccount",
    AddToApplicationThroughPersonalAccount: "NylasIntegration/AddToApplicationThroughPersonalAccount",
    AddToApplicationThroughCorporateAccount: "NylasIntegration/AddToApplicationThroughCorporateAccount",
    GetPersonalAccounts: "NylasIntegration/GetPersonalAccounts",
    GetMasterAccount: "NylasIntegration/GetMasterAccount",
    EmailandCalendarCorporateLogin: "NylasIntegration/EmailandCalendarCorporateLogin",
    EmailandCalendarPersonalLogin: "NylasIntegration/EmailandCalendarPersonalLogin",
    GetCorporateCalendarEvents: "NylasIntegration/GetCorporateCalendarEvents",
    GetPersonalCalendarEvents: "NylasIntegration/GetPersonalCalendarEvents",
    GetCorporateAccountById: "NylasIntegration/GetCorporateAccountById",
    GetPersonalAccountById: "NylasIntegration/GetPersonalAccountById",
    UnlinkPersonalAccount: "NylasIntegration/UnlinkPersonalAccount",
    UnlinkCorporateAccount: "NylasIntegration/UnlinkCorporateAccount",
    GetIMapConfigurationByUserId: "NylasIntegration/GetIMapConfigurationByUserId",
    SaveIMapConfigurations: "NylasIntegration/SaveIMapConfigurations",
    GetPersonalEmailFolders: "NylasIntegration/GetPersonalEmailFolders",
    GetCorporateEmailFolders: "NylasIntegration/GetCorporateEmailFolders",
    GetPersonalEventsInformation: "NylasIntegration/GetPersonalEventsInformation",
    GetCorporateEventsInformation: "NylasIntegration/GetCorporateEventsInformation",
    GetAccountType: "NylasIntegration/GetAccountType",
    GetConfiguredAccounts: "NylasIntegration/GetConfiguredAccounts"
  },
  Stripe: {

    CreateCheckoutSession: "Stripe/CreateCheckoutSession",
    GetStripeBillingDetail: "Stripe/GetCustomerPaymentMethod?id=",
    SaveStripeBillingDetail: "Stripe/SaveBillingDetail",
    CreateStripePaymentMethod: "Stripe/CreatePaymentMethod",
    GetStripeCustomerPaymentDetail: "Stripe/GetCustomerPaymentMethodDetail",
    CreateStripeCheckOutSession: "Stripe/CreateCheckOutSession?paymentType=",
    DeletePaymentMethod: "Stripe/DeletePaymentMethod?id=",
    GetVonqCampaignsOrderReceipts: "MarketPlace/GetCampaignsOrderReceipts",
    GetOrderReceipt: "Stripe/GetOrderReceipt?id=",
    GetPaymentReceiptDetail: "Stripe/GetReceiptDetail",
    GetPayment_PostToVonq_Status: "MarketPlace/CheckPaymentAndPostToVonqStatus"

  },
  bankInfo: {
    SaveBankInformation: "iTrentPriory/SaveBankInformation",
    GetBankInformation: "iTrentPriory/GetBankInformation?CandidateId="
  },
  Totalobs: {
    GetJobInfo: "TotalJobs/GetJobDetailsForTotalJobs?jobId=",
    GetMinMaxSalary: "TotalJobs/GetMinMaxSalary?rateUnit=",
  },
  AdditionalStarterForm: {
    GetjobLegalEntityData_Server: "EuIntegration/GetjobLegalEntityData",
    GetcompPayGroupData_Server: "EuIntegration/GetcompPayGroupData",
    GetcompRPayComponentData_Server: "EuIntegration/GetcompRPayComponentData",
    GetcompRFrequencyData_Server: "EuIntegration/GetcompRFrequencyData",
    GetUserGender_Server: "EuIntegration/GetGender_Server",
    SaveeAdditionalForm: "EuIntegration/SaveeAdditionalStarterForm",
    GetAdditionalForm: "EuIntegration/GetAdditionalForm"
  },
  SmartSearch: {
    GetCandidateInfo: "Job/CandidateInfo",
    GetCandidatesDetail: "Job/CandidatesDetail",
    GetAccessTokenAndMetaData: "Search/GetAccessTokenAndMetaData?",
    Search: "Search/Search",
    getClientEnvironmentAndMatchData: "Search/GetSearchEnvironmentAndMatchData"
  },
  OnBoarding: {
    GetDocumentLibrariesList: "OnBoarding/GetDocumentLibrariesList",
    Save: "OnBoarding/SaveDocumentLibraries",
    GetById: "OnBoarding/GetDocumentLibrariesById?id=",
    Archived: "OnBoarding/ArchiveDocumentLibraries",
    NameParams: "&controllerName=",
    GetMyStarterListing: "OnBoarding/GetMyStarterListing",
    GetOnboardingHubMyStarterListing: "OnBoarding/GetOnboardingHubMyStarterListing",
    GetOnboardingHubComplianceListing: "OnBoarding/GetOnboardingHubComplianceListing",

    UpdateCandidateOnBoardingStatus: "OnBoarding/UpdateCandidateOnBoardingStatus",
    RemoveOnBoardingProcess: "OnBoarding/RemoveOnBoardingProcess",
    RemoveOnBoardingReferences: "OnBoarding/RemoveOnBoardingReferences",
    UpdateCandidateComplianceStatus: "OnBoarding/UpdateCandidateComplianceStatus",
    GetOnboardingSetupInfo: "OnBoarding/GetOnboardingSetupInfo",
    GetComplianceTemplates: "Onboarding/GetComplianceTemplates",
    GetGreenRoomTemplates: "Onboarding/GetGreenRoomTemplates",
    GetTargetCompletionStatuses: "Onboarding/GetTargetCompletionStatuses",
    SaveOBStep1: "OnBoarding/SaveOBStep1",
    StartOnboardingProcessStep1: "OnBoarding/StartObProcessStep1",
    StartOnboardingProcessStep2: "OnBoarding/StartObProcessStep2",
    GetOBStep2: "OnBoarding/GetOBStep2",
    GetComplianceStep2: "OnBoarding/GetComplianceStep2",
    SaveOBStep2: "OnBoarding/SaveOBStep2",
    IsReferencesSectionEnabled: "OnBoarding/IsReferencesSectionEnabled",
    GetReferenceStep1: "OnBoarding/GetReferenceStep1",
    SaveReferencesStep1: "OnBoarding/SaveReferencesStep1",
    GetReferencesStep2: "OnBoarding/GetReferencesStep2",
    SaveReferencesStep2: "OnBoarding/SaveReferencesStep2",
    SaveRemainingReferences: "OnBoarding/SaveRemainingReferences",
    GetReferencesStep3: "OnBoarding/GetReferencesStep3",
    GetObRefSetp1: "OnBoarding/GetObRefSetp1",
    SaveOBRefStep1: "OnBoarding/SaveOBRefStep1",
    GetPreviewForm: "OnBoarding/GetPreviewForm",
    GetPreviewManualReference: "OnBoarding/GetPreviewManualReference",
    UploadManualReference: "OnBoarding/UploadManualReference",
    GetOBContract: "OnBoarding/GetOBContract",
    SaveOBContract: "OnBoarding/SaveOBContract",
    ReplaceContract: "OnBoarding/ReplaceContract",
    ReplaceDocument: "OnBoarding/ReplaceDocument",
    ReplaceComplianceDocument: "OnBoarding/ReplaceComplianceDocument",
    GetMyReferencesListing: "OnBoarding/GetMyReferencesListing",
    GetOnboardingHubReferenceListing: "OnBoarding/GetOnboardingHubReferenceListing",
    DeleteMyReferences: "OnBoarding/DeleteMyReferences",
    GetOBDetails: "OnBoarding/GetOBDetails",
    GetHomeMyStarterListing: "OnBoarding/GetHomeMyStarterListing",
    UpdateDocumentStatus: "OnBoarding/UpdateDocumentStatus",
    GetReferenceForm: "OnBoarding/GetReferenceForm",
    ReplaceAssessmentForm: "OnBoarding/ReplaceAssessmentForm",
    ReplaceComplianceAssessmentForm: "OnBoarding/ReplaceComplianceAssessmentForm",
    GetRemainingReferences: "OnBoarding/GetRemainingReferences",
    SaveTeams: "OnBoarding/SaveTeams",
    GetTeamsById: "OnBoarding/GetTeamsById?id=",
    GetTeamsList: "OnBoarding/GetTeamsList",
    DeleteTeams: "OnBoarding/DeleteTeams",
    CopyTeams: "OnBoarding/CopyTeams",
    RaiseGapAndConcern: "OnBoarding/RaiseGapAndConcern",
    GetCMPDetails: "OnBoarding/GetCMPDetails",
    CancelledRefrence: "OnBoarding/CancelledRefrence",
    UpdateComplianceDocumentStatus: "OnBoarding/UpdateComplianceDocumentStatus",
    UpdateComplianceItem: "OnBoarding/UpdateComplianceItem",
    GetComplianceItemData: "OnBoarding/GetComplianceItemData",
    GetManagerTabAccess: "OnBoarding/GetManagerTabAccess",
    SaveCompliance: "OnBoarding/SaveCompliance",
    GetOnboardingStates: "OnBoarding/GetOboardingStates?includeHidden=",
    GetReferenceStates: "OnBoarding/GetReferenceStates?includeHidden=",
    GetComplianceStates: "OnBoarding/GetComplianceStates?includeHidden=",
    GetOnboardingItemData: "OnBoarding/GetOnboardingItemData",
    SaveOnboardDocument: "OnBoarding/SaveOnboardDocument",
    UpdateRefrenceFormStatus: "OnBoarding/UpdateRefrenceFormStatus",
    GetOverviewStats: "OnBoarding/GetOverviewStats?includeHidden=",
    GetGapAndConcernDefaultEmail: "OnBoarding/GetGapAndConcernDefaultEmail",
    CheckCandidateAnswer: "OnBoarding/CheckCandidateAnswer",
    SaveReferences: "OnBoarding/SaveReferences",
    GetReference: "OnBoarding/GetReference",
      GetReferencesHistory: "Onboarding/GetReferencesHistory",
      GetPreviewComplianceContract: "Onboarding/GetPreviewComplianceContract",
    GetOnboardingForms: "Onboarding/GetOnboardingForms",
    GetComplianceForms: "Onboarding/GetComplianceForms",
    GetComplianceDocuments: "Onboarding/GetComplianceDocuments",
    GetOnboardingDocuments: "Onboarding/GetOnboardingDocuments",
    GetContracts: "Onboarding/GetContracts",
    PreviewContract: "CandidateOnboardProcess/PreviewContract",
    GetContract: "CandidateOnboardProcess/GetContract?contractId="
  },
  CandidateOnboardProcess: {
    StartOnboarding: "CandidateOnboardProcess/StartOnboarding",
    StartCompliance: "CandidateOnboardProcess/StartCompliance",
    StartReference: "CandidateOnboardProcess/StartReferences",
    GetOnboardingTemplateDocuments: "CandidateOnboardProcess/GetOnboardingTemplateDocuments",
    GetComplianceTemplateDocuments: "CandidateOnboardProcess/GetComplianceTemplateDocuments",
    GetReferences: "CandidateOnboardProcess/GetReferences",
    UpdateOnBoardingPendingDocuments: "CandidateOnboardProcess/UpdateOnBoardingPendingDocuments",
    UpdateCompliancePendingDocuments: "CandidateOnboardProcess/UpdateCompliancePendingDocuments"
    }, 
  LibraryType: {
    GetLibraryTypesList: "OnBoarding/GetLibraryTypesList",
    SaveLibraryTypes: "OnBoarding/SaveLibraryTypes",
    GetLibraryTypesById: "OnBoarding/GetLibraryTypesById?id=",
    NameParams: "&controllerName=",
  },
  ComplianceLibraryType: {
    GetComplianceLibraryTypesList: "OnBoarding/GetComplianceLibraryTypesList",
    SaveComplianceLibraryTypes: "OnBoarding/SaveComplianceLibraryTypes",
    GetComlianceLibraryTypesById: "OnBoarding/GetComlianceLibraryTypesById?id=",
    NameParams: "&controllerName=",
  },

  MediaLibraries: {
    GetMediaLibrariesList: "OnBoarding/GetMediaLibrariesList",
    GetOnBoardingImageList: "OnBoarding/GetOnBoardingImageList",
    GetOnBoardingTextList: "OnBoarding/GetOnBoardingTextList",
    GetOnBoardingVideoList: "OnBoarding/GetOnBoardingVideoList",
    SaveMediaLibrary: "OnBoarding/SaveMediaLibrary",
    SaveOnBoardingImage: "OnBoarding/SaveOnBoardingImage",
    SaveOnBoardingText: "OnBoarding/SaveOnBoardingText",
    SaveOnBoardingVideo: "OnBoarding/SaveOnBoardingVideo",
    GetMediaLibraryById: "OnBoarding/GetMediaLibraryById?id=",
    GetOnBoardingImageById: "OnBoarding/GetOnBoardingImageById?id=",
    GetOnBoardingTextById: "OnBoarding/GetOnBoardingTextById?id=",
    GetOnBoardingVideoById: "OnBoarding/GetOnBoardingVideoById?id=",

    Archived: "OnBoarding/DeleteMediaLibrary",
    GetOnBoardingImageArchived: "OnBoarding/GetOnBoardingImageArchived",
    GetOnBoardingTextArchived: "OnBoarding/GetOnBoardingTextArchived",
    GetOnBoardingVideoArchived: "OnBoarding/GetOnBoardingVideoArchived",
    NameParams: "&controllerName=",
    defaultImage: "OnBoarding/GetMediaLibraryDefaultImage?id=",
  },

  ConverterDB: {
    SanitizeFile: "ConverterDB/SanitizeFile",
    SanitizeMultipleFiles: "ConverterDB/SanitizeMultipleFiles",
    GetClientSideQueuedDocsById: "ConverterDB/GetClientSideQueuedDocsById?FileId=",
    SanitizeGreenRoomFile: "ConverterDB/UploadMediaGreenRoom",
    GetClientSideNotificationMessages: "ConverterDB/GetClientSideNotificationMessages",
  },

  GreenRoomTemplates: {
    GetGreenRoomTemplatesList: "GreenRoomSetUp/GetGreenRoomTemplatesList",
    Save: "GreenRoomSetUp/SaveGreenRoomTemplates",
    GetById: "GreenRoomSetUp/GetGreenRoomTemplatesById?id=",
    GetGreenRoomTemplates_Lookup: "GreenRoomSetUp/GetGreenRoomTemplates_Lookup",
    Archived: "GreenRoomSetUp/DeleteGreenRoomTemplates",
    NameParams: "&controllerName=",
    GetMediaLibrariesList: "GreenRoomSetUp/GetMediaLibraryList?type=",
    Copy: "GreenRoomSetUp/CopyGreenRoomTemplates",
    GetFooterHeading: "GreenRoomSetUp/GetFooterHeaderInformation",

  },

  KeyContacts: {
    GetKeyContactsList: "GreenRoomSetUp/GetKeyContactsList",
    Save: "GreenRoomSetUp/SaveKeyContacts",
    GetById: "GreenRoomSetUp/GetKeyContactsById?id=",
    Archived: "GreenRoomSetUp/DeleteKeyContacts",
    NameParams: "&controllerName=",
  },
  Links: {
    GetLinksList: "GreenRoomSetUp/GetLinksList",
    Save: "GreenRoomSetUp/SaveLinks",
    GetById: "GreenRoomSetUp/GetLinksById?id=",
    Archived: "GreenRoomSetUp/DeleteLinks",
    NameParams: "&controllerName=",
  },

  Managers: {
    GetManagersList: "GreenRoomSetUp/GetManagersList",
    Save: "GreenRoomSetUp/SaveManagers",
    GetById: "GreenRoomSetUp/GetManagersById?id=",
    Archived: "GreenRoomSetUp/DeleteManagers",
    NameParams: "&controllerName=",

  },

  OnBoardingSettings: {
    GetOnBoardigSettings: "OnBoarding/GetOnBoardingSettings",
    Save: "OnBoarding/SaveOnBoardigSettings",
    NameParams: "&controllerName=",
    DeleteCheckList: "OnBoarding/DeleteCheckList?id=",
    GetOnbhoardingStatuses: "OnBoarding/GetOnbhoardingSettingsStatuses",

  },

  DataListView: {
    SaveSearchRecords: "Search/SaveSearchRecords",
    GetTalentPools: "LookUp/GetTalentPools",
    AssignToTalentPool: "CandidateDetail/AssignToTalentPool",
    AssignToJob: "CandidateDetail/AssignToJob",
    MoveToJob: "CandidateDetail/MoveToJob",
    SendSms: "CandidateDetail/SendSms",
    SendEmailToQueue: "Job/SendEmail",
    GetCandidateDetails: "Search/GetCandidateDetails?CandidateId=",
    ForwardDetailEmail: "Job/ForwardDetailEmail",
    SendToAgency: "Job/SendToAgency",
    SendToReference: "Job/SendToReference",
    GetReferees: "Job/GetReferees",
    GetAgencyById: "Job/GetAgencyById?AgencyId=",
    TagReplacement: "Job/TagReplacement",
    TagReplacements: "Job/TagReplacements",
    OnboardingSendToReference: "OnBoarding/SendToReference",
    RaiseGapAndConcern: "Job/RaiseGapAndConcern",
    OfferEmail: "Job/SendOfferEmail",
    GetOfferEmail: "Job/GetOfferEmail",
    SendEmailToUser: "Job/SendEmailToUser",
    SanitizedFileScan: "FileScan/ScanFile",
    ForwardDetailEmailForTalentPool: "TalentNetwork/ForwardDetailEmail",
  },
  SystemSettings: {
    GetListing: "SystemSettings/GetListing",
    Save: "SystemSettings/Save",
    GetById: "SystemSettings/GetById?id=",
    Archived: "SystemSettings/Archived",
    NameParams: "&controllerName=",
    GetAuthorisationTemplateListing: "SystemSettings/GetAuthorisationTemplateListing",
    GetTeamListing: "SystemSettings/GetTeamListing",
    TeamSave: "SystemSettings/TeamSave",
    GetTeamById: "SystemSettings/GetTeamById?id=",
    TeamArchived: "SystemSettings/TeamArchived",
    GetAuthorisationTemplatesListing: "SystemSettings/GetAuthorisationTemplatesListing",
    AuthorisationTemplateSave: "SystemSettings/AuthorisationTemplateSave",
    SwapApprover: "SystemSettings/SwapApprover",
    GetAwaitingApprovalJobsById: "SystemSettings/GetAwaitingApprovalJobsById?id=",
    GetAuthorisationTemplateById: "SystemSettings/GetAuthorisationTemplateById?id=",
    ResetAuthorisationTemplateById: "SystemSettings/ResetAuthorisationTemplateById?id=",
    GetAuthorisationEmailTemplate: "SystemSettings/GetAuthorisationEmailTemplate",
    AuthorisationTemplateArchived: "SystemSettings/AuthorisationTemplateArchived",
    GetAuthorisationUserListing: "SystemSettings/GetAuthorisationUserListing",
    AuthorisationUserSave: "SystemSettings/AuthorisationUserSave",
    GetAuthorisationUserById: "SystemSettings/GetAuthorisationUserById?id=",
    CopyAuthorisationTemplate: "SystemSettings/CopyAuthorisationTemplate",
    AuthorisationUserArchived: "SystemSettings/AuthorisationUserArchived",
    GetUserDetails: "SystemSettings/GetUserDetails",
    SendContactEmail: "SystemSettings/SendContactEmail",
    GetSystemPipelineListing: "SystemSettings/GetSystemPipelineListing",
    SaveSystemPipeline: "SystemSettings/SaveSystemPipeline",
    GetSystemPipelineStatuses: "SystemSettings/GetSystemPipelineStatuses",
    EmailSecurityCode: "SystemSettings/EmailSecurityCode",
    VerifySecurityCode: "SystemSettings/VerifySecurityCode",
    ChangePassword: "SystemSettings/ChangePassword",
    UpdateSystemUserPassword: "SystemSettings/UpdateUserPassword",
    GetDynamicStyles: "SystemSettings/GetDynamicStyles",
    InsertUserExportHistory: "SystemSettings/InsertUserExportHistory",
    SaveDirectApplyApplicationForm: "SystemSettings/SaveDirectApplyApplicationForm/",
  },
  AuthorisationSetUp: {
    GetAuthorisationGroupsListing: "AuthorisationSetUp/GetAuthorisationGroupListing",
    SaveAuthorisationGroup: "AuthorisationSetUp/SaveAuthorisationGroup",
    GetAuthorisationGroupById: "AuthorisationSetUp/GetAuthorisationGroupById?id=",
    AuthorisationGroupArchived: "AuthorisationSetUp/ArchiveAuthorisationGroup",
    SaveJobAuthorisationMasterTemplate: "AuthorisationSetUp/SaveJobAuthorisationMasterTemplate",
    GetJobAuthorisationMasterTemplate: "AuthorisationSetUp/GetJobAuthorisationMasterTemplate?id=",
    ValidateAuthorisationCategory: "AuthorisationSetUp/ValidateAuthorisationCategory?category=",
    DeleteJobAuthorisationMasterTemplateLevelById: "AuthorisationSetUp/DeleteJobAuthorisationMasterTemplateLevelById?id=",
    GetWorkFlowLinkedUser: "AuthorisationSetUp/GetWorkFlowLinkedUser",
  },
  MultiDocument: {
    Tiles: "Settings/GeneralSettings",
    GetListing: "MultiDocument/GetListing",
    Save: "MultiDocument/Save",
    GetById: "MultiDocument/GetById?id=",
    Archived: "MultiDocument/Archived",
    NameParams: "&controllerName=",
    GetDocumentPreview: "MultiDocument/GetDocumentPreview",
    SaveMultiDocuments: "MultiDocument/SaveMultiDocuments",
    GetMultiDocumentById: "MultiDocument/GetMultiDocumentById?id=",
    MultiDocumentArchived: "MultiDocument/MultiDocumentArchived",
    GetMultiDocumentListing: "MultiDocument/GetMultiDocumentListing",
  },
  Candidate: {
    IsCandidateTalentApplicationExist: "Candidate/IsCandidateTalentApplicationExist?candidateId=",
    GetCandidateNames: "Candidate/GetCandidateNames",
    GetCandidateNamesAndIds: "Candidate/GetCandidateNamesAndIds",
    RemoveAlertNotes: "Candidate/RemoveAlertNotes",
    GetAssessmentFormQuestions: "Candidate/GetAssessmentFormQuestions?AssessmentFormId=",
    ListNoteAlerts: "Candidate/ListNoteAlerts",
    GetTemplateDetails: "Candidate/GetTemplateDetails",
    GetSavedDetails: "Candidate/GetSavedDetails",
    GetSavedEducationDetails: "Candidate/GetSavedEducationDetails",
    DeleteSavedDetails: "Candidate/DeleteSavedDetails",
    SaveEmploymentGap: "Candidate/SaveEmploymentGap",
    GetCVPreviewDetails: "Candidate/GetCVPreviewDetails",
    GetCVDetails: "Candidate/GetCVDetails",
    GetPreferences: "Candidate/GetPreferences",
    SavePreferences: "Candidate/SavePreferences",

    GetMultiDocsDetails: "Candidate/GetMultiDocsDetails",
    SaveTemplateData: "Candidate/SaveTemplateData",
    SaveCandidateImages: "Candidate/SaveCandidateImages",
    GetCandidateImages: "Candidate/GetCandidateImages",
    GetDeclarationDetails: "Candidate/GetDeclarationDetails",
    SaveCVAndCoverLetter: "Candidate/SaveCVAndCoverLetter",
    SaveMultiDocs: "Candidate/SaveMultiDocs",
    GetAssessmentDetails: "Candidate/GetAssessmentDetails",
    GetAssessmentFormsDetail: "Candidate/GetAssessmentFormsDetail",
    GetAssessmentBDetails: "Candidate/GetAssessmentBDetails",
    GetPreAssessmentDetails: "Candidate/GetPreAssessmentDetails",
    SelectAssessmentForm: "Candidate/SelectAssessmentForm",
    SaveAssessmentFormAnswers: "Candidate/SaveAssessmentFormAnswers",
    PrintApplication: "Candidate/PrintApplication",
    GetLeftMenuData: "Candidate/GetLeftMenuData",
    GetCandidateDetailSecurityRoles: "Candidate/GetCandidateDetailSecurityRoles",
    GetSecurityRoleDetails: "Candidate/GetSecurityRoleDetails",
    GetPrintLetterData: "Candidate/GetPrintLetterData",
    PrintLetter: "Candidate/PrintLetter",
    GetPrintContractData: "Candidate/GetPrintContractData",
    PrintContract: "Candidate/PrintContract",
    CompareCandidates: "Candidate/CompareCandidates",
    GetOfferAuthorizationStep1: "CandidateOfferAuthorization/GetOfferAuthorizationStep1",
    SaveOfferAuthorizationStep1: "CandidateOfferAuthorization/SaveOfferAuthorizationStep1",
    GetOfferAuthorizationStep2: "CandidateOfferAuthorization/GetOfferAuthorizationStep2",
    StartTimedForm: "Candidate/StartTimedForm",
    UpdateApplicationTimedCandidateFromGroupTime: "Candidate/UpdateApplicationTimedCandidateFromGroupTime",
    UpdateApplicationTimedCandidateFromGroup: "Candidate/UpdateApplicationTimedCandidateFromGroup",
    GetSpecialAdjustmentDetails: "Candidate/GetSpecialAdjustmentDetails",
    SaveSpecialAdjustmentDetails: "Candidate/SaveSpecialAdjustmentDetails",
    GetResetTestDetails: "Candidate/GetResetTestDetails",
    ResetTest: "Candidate/ResetTest",
    SaveDeclaration: "Candidate/SaveDeclaration",
    CandidateApplicationInterview: "Candidate/CandidateApplicationInterview",
    BookCandidateInterview: "Candidate/BookCandidateInterview",
    BookCandidateInterviewDelete: "Candidate/BookCandidateInterviewDelete",
    GetEmailTemplatesByIds: "Candidate/GetEmailTemplatesByIds",
    SignOutFromTeam: "MsTeam/SignOutFromTeam",
    CandidateApplicationInterviewDelete: "Candidate/CandidateApplicationInterviewDelete",
    CandidateDetail: "Candidate/CandidateDetail?candidateParams=",
    GetMsTeamLoggedInUser: "MsTeam/GetMsTeamLoggedInUser?teamUserId=",
    CandidateInterviewDetail: "Candidate/CandidateInterviewDetail?candidateId=",
    ListAppointments: "Candidate/ListAppointments?candidateId=",
    ListSlots: "Candidate/ListSlots?candidateId=",
    AppointmentConfirm: "Candidate/AppointmentConfirm?candidateId=",
    BookAppointment: "Candidate/BookAppointment",
    CancelAppointment: "Candidate/CancelAppointment?candidateId=",
    GetCandidateJobId: "/Candidate/GetCandidateJobId?id=",
    NameParams: "&jobId=",
    TeamUser: "&teamUserId=",
    SaveTattoImage: "Candidate/SaveTattoImage",
    GetCandidate: "Candidate/GetCandidate",
    CandidateRegister: "Candidate/CandidateRegister",
    GetPrioryDocuments: "Candidate/GetPrioryDocuments?candidateId=",
    GetCandidateAttachedForm: "Candidate/GetCandidateAttachedForm?candidateId=",
    GetCandidateEmailAddress: "Candidate/GetCandidateEmailAddress",
    AddNewCandidate: "PrivateJob/GetCandidate",
    SendInvitationToCandidate: "PrivateJob/InviteCandidates",
    GetDefaultEmailTemplate: "PrivateJob/GetDefaultEmailTemplate",
    GetInvitationHistory: "PrivateJob/GetInvitationHistory",
    PreviewEmail: "PrivateJob/PreviewEmail?JobId=",
    GetPrivateJobEmailText: "PrivateJob/GetPrivateJobEmailText?JobId=",
    HasCandidateAppliedForJob: "PrivateJob/HasCandidateAppliedForJob?candidateId=",
    GetCandidateType: "PrivateJob/GetCandidateType?candidateId=",
    GetCandidates: "PrivateJob/GetCandidates",
    GetCandidateDetails: "Candidate/GetCandidateDetails",
  },
  Education: {
    DeleteEducation: "Education/DeleteEducation",
    CopyEmployment_References: "Education/CopyEmployment_References",
    GetEducationDetails: "Education/GetEducationDetails",
    GetReferenceCount: "Education/GetReferenceCount",
    SaveEducationWithMultipleSubjects: "Education/SaveEducationWithMultipleSubjects"
  },
  Talents: {
    GetListing: "Talent/GetOfferAuthorizationListing",
    Save: "Talent/Save",
    GetById: "Talent/GetById?id=",
    Archived: "Talent/Archived",
    Delete: "Talent/Delete",
    GetTalentPoolById: "Talent/GetTalentPoolById?id=",
    NameParams: "&controllerName=",
    GetTalentCommunityById: "Talent/GetTalentCommunityById?id=",
    GetTalentListing: "Talent/GetTalentListing",
    GetTalentCaptureListing: "Talent/GetTalentCaptureListing",
    ArchivedTalent: "Talent/ArchivedTalent",
    GetPoolCandidateListing: "Talent/GetPoolCandidateListing?TalentPoolId=",
    SaveTalenPoolCandidateRanking: "Talent/SaveTalenPoolCandidateRanking",
    GetNotification: "Talent/GetNotification",
    GetMediaLibraryListingData: "Talent/GetMediaLibraryListingData",
    ImagePreviewContent: "Talent/ImagePreviewContent"




  },


  Mylocums: {
    GetRegionsList: "MyLocums/GetRegionsList",
    GetLocatoinsByRegionsIdsList: "MyLocums/GetLocatoinsByRegionsIdsList",
    GetLocatoinsByIds: "MyLocums/GetLocatoinsByIds",
    GetLocumsCandidateList: "MyLocums/GetLocumsCandidateList",
  },



  GradeFare: {
    GetListOfTalent: "GradeFare/GetListOfTalent",
    TalentCandidateDetail: "GradeFare/TalentCandidateDetail",
    AddTalentCandidateNote: "GradeFare/AddTalentCandidateNote",
    GetTalentCandidateNote: "GradeFare/GetTalentCandidateNote",
    RemovCandidatesFromTalentCommunity: "GradeFare/RemovCandidatesFromTalentCommunity",
    TagReplacement: "GradeFare/TagReplacement",
    GetSendEmailData: "GradeFare/GetSendEmailData",
    SendEmail: "GradeFare/SendEmail",
    AssignToJob: "GradeFare/AssignToJob",
    GetTalentCandidateDetail: "GradeFare/GetTalentCandidateDetail",
    SaveCandidate: "GradeFare/SaveCandidate",
    GetCandidate: "GradeFare/GetCandidate?id=",
    GetSentEmails: "GradeFare/GetSentEmails",
    GetHistory: "GradeFare/GetHistory",
    GetHeaderFoter: "GradeFare/GetHeaderFooter",
    GetCV: "GradeFare/GetCV",
    SearchUniversity: "GradeFare/SearchUniversity",
    GetCommunityName: "GradeFare/GetCommunityName?id=",
    GetSentEmailDetails: "GradeFare/GetSentEmailDetails?id=",
  },
  WorkPlace: {
    GetMyNewApplicationListing: "Talent/GetMyNewApplicationListing",
    GetCandidateShortlisting: "Talent/GetCandidateShortlisting",
    MyJobs: "Job/GetMyJobs",
    AddtoMyJobs: "Job/AddtoMyJobs",
    RemoveMyJobs: "Job/RemoveMyJobs",
    ApproveJob: "Requisition/Approved",
    RejectJob: "Requisition/Reject",



    UsersUpload: "Job/UsersUpload",
    LeaversUpload: "Job/LeaversUpload"
  },
  VideoInterviewIntegration: {
    LaunchPadPlayBackApi: "Integration/LaunchPadPlayBackApi",
    GetInterviews: "Integration/GetInterviews",
    InviteToInterview: "Integration/CreateCandidate",
    GetInterviewDetails: "Integration/GetInterviewDetails",
    InviteCandidateToRetakeInterview: "Integration/InviteCandidateToRetakeInterview",
    GetVideoAttachmentDetail: "Integration/GetVideoAttachmentDetail",
    SaveInterViewVideoNotes: "Integration/SaveInterViewVideoNotes",
    HostUrl: "https://global.gotomeeting.com",
    ShareUrl: "https://cdn.recordingassets.logmeininc.com/8583072948664881157",
  },
  Integration: {
    GetShlScore: "Integration/GetShlScore",
    ResetTest: "Integration/ResetTest",
    GetInterviews: "Integration/GetInterviews",
    GetCentralTestAssessmentReport: "Integration/GetCentralTestAssessmentReport",
    GetCandidateReportLinkCute: "Integration/GetCandidateReportLink_Cute",
    GetCandidateReportLink_Cute_EnhancedProject: "Integration/GetCandidateReportLink_Cute_EnhancedProject",
    GetScoresObj_Cute_EnhancedProject: "Integration/GetScoresObj_Cute_EnhancedProject",
    GetScoresObj_Cute: "Integration/GetScoresObj_Cute",

  },
  PrioryDlxIntegration: {
    ConvertDocumentsToPdf: "PrioryDlx/ConvertDocumentsToPdf",
    DonwloadIndividualDoc: "PrioryDlx/DonwloadIndividualDoc"

  }
  ,
  AsprisIntegration: {
    GetFile: "Aspris/GetFile",
    SendData: "Aspris/SendData",
    QueueDocuments: "Aspris/QueueDocuments",
    DirectConversion: "Aspris/DirectConversion",
    GetDlxCandidates: "Aspris/GetDlxCandidates?CandidateName="
  }
  ,
  LaunchPadIntegration: {
    GetInterviewStatus: "Integration/GetLaunchPadInterviewStatus",
    GetInterviews: "Integration/GetLaunchPadInterviews",
    InviteToInterview: "Integration/LaunchPadCreateCandidate"
  },
  LogmeInIntegration: {
    GetInterviewRooms: "LogmeInOnlineInterview/GetInterviewRooms",
    GetDurations: "LogmeInOnlineInterview/GetDurations",
    CreateMeeting: "LogmeInOnlineInterview/CreateMeeting",
    DeleteMeeting: "LogmeInOnlineInterview/DeleteMeeting?InterviewId=",
    GetAuthenticationUrl: "LogmeInOnlineInterview/GetAuthenticationUrl?RoomId=",
    GetAuthenticationCode: "LogmeInOnlineInterview/GetAuthenticationCode",
    GetHistoricalMeetings: "LogmeInOnlineInterview/GetHistoricalMeetings?InterviewId=",


  },
  OnlineDisclosureIntegration: {
    GetOnlineDisclosureInfo: "Integration/GetOnlineDisclosureInfo",
    RegisterApplicant: "Integration/RegisterApplicant",
    GetCandidateOnlineDisclouserStatusHistory: "Integration/GetCandidateOnlineDisclouserStatusHistory"

  },
  OnlineDisclosureIntegrationEnhanced: {
    GetOnlineDisclosureInfo: "IntegrationEnhanced/GetOnlineDisclosureInfo",
    RegisterApplicant: "IntegrationEnhanced/RegisterApplicant"
  },
  JobsandTalent: {
    GetTopStatConfigration: "Job/GetTopStatConfigration",
    GetClientDivisionFeatureAvailability: "Job/GetClientDivisionFeatureAvailability?sFeature=",
    GetTabsData: "Job/GetTabsData",
    ListOfCandidates: "Job/ListOfCandidates",
    GetJobTitleRef: "Job/GetJobTitleRef",
    GetApplicationFormTabData: "Job/GetApplicationFormTabData",
    UpdateCandidateStatus: "Candidate/UpdateCandidateStatus",
    BulkUpdateCandidateStatus: "Candidate/BulkUpdateCandidateStatus",

    GetCandidateCVDetail: "Candidate/GetCandidateCVDetail",
    UploadCandidateCV: "Candidate/UploadCandidateCV",

    GetJobDetails: "Job/GetJobDetails",
    GetJobListing: "Job/GetJobListing",
    GetTopStatData: "Job/GetTopStatData",
    GetJobDetail: "Job/GetJobDetail",
    GetJobNotes: "Job/GetJobNotes",
    GetJobAdverts: "Job/GetJobAdverts",
    GetSmartSearch: "Job/GetSmartSearch",
    GetApprovalForm: "Job/GetApprovalForm",
    ResendRequisition: "Job/ResendRequisition",
    ApproveRequisition: "Job/ApproveRequisition",
    GetCandidateList: "Job/GetCandidateListByJob",

    SaveJobDetails: "Job/SaveJobDetails/",
    GetCompareShortListing: "Candidate/GetCompareShortListing",
    OfferAuthorizationActions: "CandidateOfferAuthorization/OfferAuthorizationActions",
    RefreshStatus: "CandidateDetail/RefreshStatus",
    MyOfferAuthorizationActions: "CandidateOfferAuthorization/MyOfferAuthorizationActions",
    GetDiversityCount: "Home/GetDiversityCount",
    SaveJobAdverts: "Job/SaveJobAdverts/",
    SaveAssesment: "Job/SaveAssesment/",
    SaveApprovalForm: "Job/SaveApprovalForm",
    SaveJobNote: "Job/SaveJobNote",
    CheckCandidatePackSecurity: "Candidate/CheckCandidatePackSecurity",
    CheckCandidatePackDocSecurity: "Candidate/CheckCandidatePackDocSecurity",
    GetBookedCandidates: "Job/GetBookedCandidate?id=",
    GetSystemPipelines: "Job/GetSystemPipelines?id=",
    CandidateStatusUpdate: "Job/UpdateCandidateStatus/",
    GetCandidateReligionDetail: "Candidate/GetCandidateReligionDetail",
    SendBulkEmail: "Candidate/SendBulkEmail",
    GetCandidateByApplicationStatus: "Candidate/GetCandidateByApplicationStatus",
    GetTalentApplicationListing: "TalentNetwork/GetTalentApplicationListing",
    GetCandidateCV: "TalentNetwork/GetCandidateCV",
    GetCandidateCoverLetter: "TalentNetwork/GetCandidateCoverLetter",
    DeleteTalentPoolNote: "TalentNetwork/DeleteTalentPoolNote"


  },
  CandidateFieldsRecovery: {
    GetCandidateMissingFields: "CandidateFieldsRecovery/GetCandidateMissingFields",
    RestoreMissingFields: "CandidateFieldsRecovery/RestoreMissingFields"
  },
  FDMAllocation: {
    GetAllocatedCandidate: "Allocation/GetAllocatedCandidate",
    GetUnAllocatedCandidate: "Allocation/GetUnAllocatedCandidate",
    GetNewCandidate: "Allocation/GetNewCandidate",
    GetReminderCandidate: "Allocation/GetReminderCandidate",
    GetDeferredCandidates: "Allocation/GetDeferredCandidates",
    UndeferCandidates: "Allocation/UndeferCandidates",
    GetCandidateDetails: "Allocation/GetCandidateDetails?id=",
    AddCandidateNote: "Allocation/AddCandidateNote",
    GetCandidateNotes: "Allocation/GetCandidateNotes",
    GetDeferredtDetails: "Allocation/GetDeferredtDetails?id=",
    AddRemoveDeferred: "Allocation/AddRemoveDeferred",
    UpdateAllocationSetting: "Allocation/UpdateAllocationSetting",
    UnAllocateCandidate: "Allocation/UnAllocateCandidate",
    RemoveCandidateFromRecuiter: "Allocation/RemoveCandidateFromRecuiter",
    //ReAssignRecruiter: "Allocation/ReAssignRecruiter",
    GetCandidateDetailsbyApplicationId: "Allocation/GetCandidateDetailsbyApplicationId",
    AssignToRecruiter: "Allocation/AssignToRecruiter",
    AllocationSetting: "Allocation/GetAllocationSetting",
    GetUserDetails: "Allocation/GetUserDetails?id=",
    GetCandidate: "Allocation/GetCandidate",
    CandidateRegister: "Allocation/CandidateRegister",
    GetActionRules: "Allocation/GetActionRules?id=",
    GetManuallAllocationDetailByCandidate: "Allocation/GetManuallAllocationDetailByCandidate",
    DoManuallAllocationByCandidate: "Allocation/DoManuallAllocationByCandidate",
    GetPrintLetterData: "GradeFare/GetPrintLetterData",
    PrintLetter: "GradeFare/PrintLetter",



  },
  HomePage: {
    GetRecruitmentFunnelCount: "Home/GetRecruitmentFunnelCount",
    GetBottleNeck: "Home/GetBottleNeck",
    GetListHomeCandidates: "Home/GetHomeListOfCandidatesByDate",
    GetHomeCandidates: "Home/GetListOfCandidates",
    GetHomeCandidatesByDate: "Home/GetListOfCandidatesByDate",
    GetHomeClosingJobs: "Home/GetListClosingJobs",
    GetAdvert: "Home/GetAdvertReport",
    GetApplicationPerDay: "Home/GetApplicationPerDay",
    GetHomeListOfShortlistingCandidates: "Home/GetListOfShortlistingCandidates",
    GetCandidateCount: "Home/GetCandidateCount",
    GetHomeInterviews: "Home/GetListOfInterViewsForDashboard",
    SaveHomeNote: "Home/SaveHomeNote",
    DeleteHomeNote: "Home/DeleteHomeNote?id=",
    GetHomeNotes: "Home/GetHomeNotes",
    GetArchivedHomeNotes: "Home/GetArchivedHomeNotes",
    RestoreDeletedNote: "Home/RestoreDeletedNote?id=",
    GetHomeListOfOfferMadeJobCandidates: "Home/GetListOfOfferMadeJobCandidates",
    GetTimeToApprove: "Home/GetTimeToApprove",
    GetTopStatConfigration: "Home/GetTopStatConfigration",
    GetQuickLinks: "Home/GetQuickLinks",
    GetTrafficLightCount: "Home/GetTrafficLightCount",
    GetAppointments: "Home/GetAppointments",
    GetTopStatData: "Home/GetTopStatData",
    GetHelpDeskLink: "Home/GetHelpDeskLink",
    SaveToDoListTask: "Home/SaveToDoListTask",
    GetToDoTaskList: "Home/GetToDoTaskList",
    ArchiveToDoTask: "Home/ArchiveToDoTask",
    RestoreToDoTask: "Home/RestoreToDoTask",
    GetBookedInterviews: "Home/GetBookedInterviews",
  },

  ESRHub: {
    GeVacancyListing: "ESRHub/GeVacancyListing",
    GetApplicantListing: "ESRHub/GetApplicantListing",
    GetVacancyStats: "ESRHub/GetVacancyStats?statsType=",
    GetAplicantStats: "ESRHub/GetAplicantStats?statsType=",
    GetVacancyHistoryListing: "ESRHub/GetVacancyHistoryListing",
    GetApplicantHistoryListing: "ESRHub/GetApplicantHistoryListing",
    GetVacancyHistoryDetailById: "ESRHub/GetVacancyHistoryDetailById",
    GetApplicantHistoryDetailById: "ESRHub/GetApplicantHistoryDetailById",
    RemoveFromVacancyProcess: "ESRHub/RemoveFromVacancyProcess",
    RemoveFromApplicantProcess: "ESRHub/RemoveFromApplicantProcess",
    GeEmploymentListing: "ESRHub/GetEmploymentListing",
    GetEmploymentStats: "ESRHub/GetEmploymentStats?statsType=",
    GetEmploymentHistoryListing: "ESRHub/GetEmploymentHistoryListing",
    GetEmploymentHistoryDetailById: "ESRHub/GetEmploymentHistoryDetailById",

  },
  ParseUpload: {
    SaveParseCandidate: "ParseUpload/SaveParseCandidate",
    RecentlyUploadedCandidates: "ParseUpload/GetRecentUploadListing",
    RecentlyUploadedCandidatesDetails: "ParseUpload/GetRecentlyUploadedCandidateDetails",
    CandidateQualifications: "ParseUpload/GetCandidateQualifications",
    CandidateTrainingCourse: "ParseUpload/GetCandidateTrainingCourse",
    CandidatesReferences: "ParseUpload/GetCandidateReferences",
    CandidatesEmployers: "ParseUpload/GetCandidateEmployers",
    CandidatesEqualOpps: "ParseUpload/GetCandidateEqualOpps",
    RemoveCandidate: "ParseUpload/RemoveCandidate",
    CandidateImport: "ParseUpload/CandidateImportToJob",
    NHSCandidateImport: "ParseUpload/NHSCandidateImport",
  },
  CandidateDetail: {
    GetLeftMenuChecks: "CandidateDetail/GetLeftMenuChecks",
    GetCandidateListInformation: "CandidateDetail/GetCandidateListInformation",
    GetSecurityRoleStatuses: "CandidateDetail/GetSecurityRoleStatuses",
    GetCandidateDetail: "CandidateDetail/GetCandidateDetail",
    PrintApplication: "CandidateDetail/PrintApplication",
    GetOnboardingStatusId: "CandidateDetail/GetOnboardingStatusId",
    GetTabsDetail: "CandidateDetail/GetTabsDetail",
    GetMultiPanelSessionVariables: "CandidateDetail/GetMultiPanelSessionVariables",
    AppliedJobs: "CandidateDetail/AppliedJobs?CandidateId=",
    GetMultiUploadsDetails: "CandidateDetail/GetMultiUploadsDetails",
    UploadDocument: "CandidateDetail/UploadDocument",
    DocumentPreview: "CandidateDetail/DocumentPreview",
    DeleteDocument: "CandidateDetail/DeleteDocument",
    GetDocument: "CandidateDetail/GetDocument",
    GetNoteDetail: "CandidateDetail/GetNoteDetail",
    SaveNote: "CandidateDetail/SaveNote",
    GetNotes: "CandidateDetail/GetNotes",
    SetInternalExternal: "CandidateDetail/SetInternalExternal",
    DeleteApplication: "CandidateDetail/DeleteApplication",
    EmailNewPassword: "CandidateDetail/EmailNewPassword",
    EmailSecurityCode: "CandidateDetail/EmailSecurityCode",
    VarifySecurityCode: "CandidateDetail/VarifySecurityCode",
    ChangePassword: "CandidateDetail/ChangePassword",
    GetOpportunityAlerts: "CandidateDetail/GetOpportunityAlerts",
    CandidateRegisterDetail: "CandidateDetail/CandidateRegisterDetail",
    UnlockCandidateAccount: "CandidateDetail/UnlockCandidateAccount",
    RemoveAlertNotes: "CandidateDetail/RemoveAlertNotes",
    UpdateCandidateRanking: "CandidateDetail/UpdateCandidateRanking",
    IsReferenceStarted: "CandidateDetail/IsReferenceStarted",
    UpdateNotificationStatus: "CandidateDetail/UpdateNotificationStatus",
    GetApplicationStatusesAndStatusChangeReasons: "CandidateDetail/GetApplicationStatusesAndStatusChangeReasons",
    GetCandidateTemplateId: "CandidateDetail/GetCandidateTemplateId",
    GetHistoryCommints: "CandidateDetail/GetHistoryCommints",
    GetCandidateHistory: "CandidateDetail/GetCandidateHistory",
    GetSentEmailHistory: "CandidateDetail/GetSentEmailHistory",
    GetScore: "CandidateDetail/GetScore",
    ShortListComplete: "CandidateDetail/ShortListComplete",
    GetUpdateApplicationStatusesByUser: "CandidateDetail/GetUpdateApplicationStatusesByUser",
    AgencyLookup: "Search/GetLookUpData",
    GetAccessApplicationStatusesByUser: "CandidateDetail/GetAccessApplicationStatusesByUser",
    GetStatusChangeConfiguration: "CandidateDetail/GetStatusChangeConfiguration",
    ApproveRejectTattoImages: "CandidateDetail/ApproveRejectTattoImages",
    GetApproveOrRejectRecord: "CandidateDetail/GetApproveOrRejectRecord",
    GetFeatureStatusChangeEmail: "CandidateDetail/GetFeatureStatusChangeEmail",
    GetBankInfoStatus: "iTrentPriory/GetBankInfoStatus",
    GetInterviewSchemeDiscription: "CandidateDetail/GetInterviewSchemeDiscription",
    GetOnlineDisclouserStatus: "CandidateDetail/GetOnlineDisclouserStatus",
    ReinstatedApplication: "CandidateDetail/ReinstatedApplication",
    GetJobCardDetail: "CandidateDetail/GetJobCardDetail?id=",
    InterviewComplete: "CandidateDetail/InterviewComplete",
    GetSentEmailDetail: "CandidateDetail/GetSentEmailDetail?Id=",
    UpdateInterviewComplete: "CandidateDetail/UpdateInterviewComplete",
    GetPreviousApplicationCount: "CandidateDetail/GetPreviousApplicationCount",

  },

  Templates: {
    GetTemplatesList: "OnBoarding/GetTemplatesList",
    SaveTemplates: "OnBoarding/SaveTemplates",
    SaveTemplatesDocuments: "OnBoarding/SaveTemplatesDocuments",
    GetTemplatesById: "OnBoarding/GetTemplatesById",
    GetTemplates: "OnBoarding/GetSystemTemplates",
    GetDocumentById: "OnBoarding/GetDocumentLibraryById?id=",
    Archived: "OnBoarding/ArchiveTemplates",
    CopyOnboardingTemplate: "OnBoarding/CopyOnboardingTemplate",
    NameParams: "&controllerName=",
  },

  OnBoardingForm: {
    GetOnBoardingFormList: "OnBoarding/GetOnBoardingFormList",
    SaveOnBoardingForm: "OnBoarding/SaveOnBoardingForm",
    GetOnBoardingFormById: "OnBoarding/GetOnBoardingFormById?id=",
    GetAssessmentFormQuestions: "OnBoarding/GetAssessmentFormQuestions?AssessmentFormId=",
    Archived: "OnBoarding/ArchiveForm",
    UpdateOnBoardingFormQuestion: "OnBoarding/UpdateOnBoardingFormQuestion",
    GetAssessmentFormQuestion: "OnBoarding/GetAssessmentFormQuestion",
    AddAssessmentFormQuestion: "OnBoarding/AddAssessmentFormQuestion",
    GetAssessmentFormById: "OnBoarding/GetAssessmentFormById?AssessmentFormId=",
    CopyAssessmentForms: "OnBoarding/CopyAssessmentForms",
    ReOrderOnBoardingForm: "OnBoarding/ReorderOnBoardingForm?ApplicationFormId=",
    PreviewOnBoardingForm: "OnBoarding/GetPreviewOnBoardingForm?ApplicationFormId=",
    PreviewComplianceForm: "OnBoarding/GetPreviewComplianceForm?ApplicationFormId=",
    DeleteQuestions: "OnBoarding/DeleteQuestions",
    CheckQuestionNo: "OnBoarding/CheckQuestionNo",
    GetStatusesList: "OnBoarding/GetStatusesList",
    SaveStatuses: "OnBoarding/SaveStatuses",
    GetOnBoardingStatuses_Lookup_Server: "OnBoarding/GetOnBoardingStatuses_Lookup_Server",
    UpdateCandidateApplicationStatus: "OnBoarding/UpdateCandidateApplicationStatus",
    GetStatusesById: "OnBoarding/GetStatusesById?id=",
    DeleteStatuses: "OnBoarding/DeleteStatuses",
    AddCandidateNote: "OnBoarding/AddCandidateNote",
    GetCandidateNotes: "OnBoarding/GetCandidateNotes",
    GetCandidateDetailById: "OnBoarding/GetCandidateDetailById?id=",
    GetChildForComplianceCandidateApplicationDocument: "OnBoarding/GetChildForComplianceCandidateApplicationDocument",
    BulkAssignOnBoardingOwner: "OnBoarding/BulkAssignOnBoardingOwner",
    GetCandiateTemplateDetailForNotes: "OnBoarding/GetCandiateTemplateDetailForNotes",
    GetCandidateNotesGaps: "OnBoarding/GetCandidateNotesGaps",
    GetToUserFullName: "OnBoarding/GetToUserFullName",
    GetGapApprovedRejectedDetials: "OnBoarding/GetGapApprovedRejectedDetials",
    NameParams: "&controllerName=",
  },

  OnBoardingHub: {
    GetOnBoardingHubOverviewListing: "OnBoarding/GetOnBoardingHubOverviewListing",
    UploadDocument: "OnBoarding/UploadDocument",
    DocumentPreviewOB: "OnBoarding/DocumentPreviewOB",
    DocumentPreviewComliance: "OnBoarding/DocumentPreviewComliance",
    DocumentPreviewComlianceNoteTab: "OnBoarding/DocumentPreviewComlianceNoteTab",
    DocumentPreviewOnBoardingNoteTab: "OnBoarding/DocumentPreviewOnBoardingNoteTab",
    listOfOBDocuments: "OnBoarding/listOfOBDocuments",
    DeleteDocumentOB: "OnBoarding/DeleteDocumentOB",
    GetOnBoardingOwnerByApplicationId: "OnBoarding/GetOnBoardingOwnerByApplicationId?id=",
    GetCandidateObForm: "OnBoarding/GetCandidateObForm",
    SaveAssessmentFormAnswersOB: "OnBoarding/SaveAssessmentFormAnswersOB",

    GetOnBoardingHubManagerListing: "OnBoarding/GetOnBoardingHubManagerListing",

    RestoreCandidateData: "OnBoarding/RestoreCandidateData",

  },

  SystemUser: {
    SendPasswordRemainder: "SystemUser/SendPasswordRemainder?SystemUserId=",
    SendSecurityCode: "SystemUser/SendSecurityCode",
    EmailSecurityCode: "SystemUser/EmailSecurityCode?SystemUserId=",
    UpdateUserPassword: "SystemUser/UpdateUserPassword",
    InitializeUpdatePassword: "SystemUser/InitializeUpdatePassword",
    DeleteSystemUsers: "SystemUser/DeleteSystemUsers",
    UnArchiveSystemUser: "SystemUser/UnArchiveSystemUser",
    ActivateSystemUser: "SystemUser/ActivateSystemUser",
    DeActivateSystemUser: "SystemUser/DeActivateSystemUser",
    CopySystemUsers: "SystemUser/CopySystemUsers",
    GetApplicationStatus: "SystemUser/GetApplicationStatus",
    SaveUser: "SystemUser/SaveUser",
    UpdateSystemUser: "SystemUser/UpdateSystemUser",
    GetSystemUserById: "SystemUser/GetSystemUserById?SystemUserId=",
    GetUserLogs: "SystemUser/GetUserLogs",
    GetUserListing: "SystemUser/GetUserListing",
    GetUserListingArchived: "SystemUser/GetUserListingArchived",
    GetJobs: "SystemUser/GetJobs",
    GetJobsUser: "SystemUser/GetJobsUser",
    GetSystemUserData: "SystemUser/GetSystemUserData",
    GetSystemUserAdditionalDetail: "SystemUser/GetSystemUserAdditionalDetail",
    GetUserWelcomeListing: "SystemUser/GetUserWelcomeListing",
    SendWelcomeEmail: "SystemUser/SendWelcomeEmail",
    RevokeAllToken: "SystemUser/RevokeAllToken",
    RevokePreviousTokensAndKeepLast: "SystemUser/RevokePreviousTokensAndKeepLast",
    RevokeToken: "SystemUser/RevokeToken?autoRequest=jt",
    UpdateUser: "SystemUser/UpdateUser",
    UpdatePassword: "SystemUser/UpdatePassword",
    GetCurrentUserDetail: "SystemUser/GetCurrentUserDetail",
    GetPasswordComplexityDetail: "SystemUser/GetPasswordComplexityDetail",
    GetPasswordComplexityDetailNewUser: "SystemUser/GetPasswordComplexityDetailNewUser",
    UpdateJobsUser: "SystemUser/UpdateJobsUser",
    GenerateOpenApiPassword: "SystemUser/GenerateOpenApiPassword",
    UpdatePersonalSetting: "SystemUser/UpdatePersonalSetting",
    GetUserLogById: "SystemUser/GetUserLogById?id=",

  },
  AssessmentForm: {
    GetAssessmentFormQuestions: "AssessmentForm/GetAssessmentFormQuestions?AssessmentFormId=",
    GetApplicationFormQuestionGroupImage: "AssessmentForm/GetApplicationFormQuestionGroupImage?GroupId=",
    GetApplicationFormGroupQuestions: "AssessmentForm/GetApplicationFormGroupQuestions?GroupId=",
    AddAssessmentForm: "AssessmentForm/AddAssessmentForm",
    UpdateAssessmentForm: "AssessmentForm/UpdateAssessmentForm",
    GetAssessmentFormById: "AssessmentForm/GetAssessmentFormById?AssessmentFormId=",
    DeleteQuestions: "AssessmentForm/DeleteQuestions",
    ReOrderApplicationFormQuestions: "AssessmentForm/ReOrderApplicationFormQuestions?ApplicationFormId=",

    CopyAssessmentForms: "AssessmentForm/CopyAssessmentForms",
    DeleteAssessmentForms: "AssessmentForm/DeleteAssessmentForms",
    GetAssessmentFormListing: "AssessmentForm/GetAssessmentFormListing",

    GetQuestionsBankListing: "AssessmentForm/GetQuestionsBankListing",
    DeleteQuestionTemplate: "AssessmentForm/DeleteQuestionTemplate",

    AddQuestionGroup: "AssessmentForm/AddQuestionGroup",
    GetApplicationFormQuestionGroups: "AssessmentForm/GetApplicationFormQuestionGroups?ApplicationFormId=",
    DeleteApplicationFormGroup: "AssessmentForm/DeleteApplicationFormGroup?QuestionGroupId=",
    GetAssessmentFormGroupQuestions: "AssessmentForm/GetAssessmentFormGroupQuestions",
    CopyTimedForms: "AssessmentForm/CopyTimedForms",
    GetBankQuestions: "AssessmentForm/GetBankQuestions?QuestionTemplateId=",
    GetDirectApplyApplicationTemplateData: "AssessmentForm/GetDirectApplyApplicationTemplateData",
    CopyBankQuestions: "AssessmentForm/CopyBankQuestions",
    IsFormInUse: "AssessmentForm/IsFormInUse?formId=",
  },
  MediaLibrary: {
    SaveMediaLibraryText: "MediaLibrary/SaveMediaLibraryText",
    GetMediaLibraryByIdText: "MediaLibrary/GetMediaLibraryByIdText?MediaLibraryId=",
    GetMediaLibraryListingText: "MediaLibrary/GetMediaLibraryListingText",
    DeleteMediaLibraryText: "MediaLibrary/DeleteMediaLibraryText",
    SaveMediaLibraryVideo: "MediaLibrary/SaveMediaLibraryVideo",
    GetMediaLibraryByIdVideo: "MediaLibrary/GetMediaLibraryByIdVideo?MediaLibraryId=",
    GetMediaLibraryListingVideo: "MediaLibrary/GetMediaLibraryListingVideo",
    DeleteMediaLibraryVideo: "MediaLibrary/DeleteMediaLibraryVideo",
    SaveMediaLibraryImage: "MediaLibrary/SaveMediaLibraryImage",
    GetMediaLibraryByIdImage: "MediaLibrary/GetMediaLibraryByIdImage?MediaLibraryId=",
    GetMediaLibraryListingImage: "MediaLibrary/GetMediaLibraryListingImage",
    DeleteMediaLibraryImage: "MediaLibrary/DeleteMediaLibraryImage"
  },
  SystemListing: {
    GetSystemListingPageActions: "SystemListing/GetSystemListingPageActions?Pageid="
  },
  CheckListModal: {
    GetCheckList: "Job/GetCheckList",
    SaveCheckList: "Job/SaveCheckList",
    GetAdditionalCheckList: "Job/GetAdditionalCheckList",
    SaveAdditionalCheckList: "Job/SaveAdditionalCheckList"
  },
  StarterFormModal: {
    GetStarterFormHtml: "Job/GetStarterForm",
    directConversion: "Job/directConversion",
    GetStarterFormExtraHtml: "Job/GetStarterForm2",
    GetDataToCSVFormHtml: "Job/GetExportToCSVStarterForm",
    GetDataToCSVFormCarr1Html: "Job/GetExportToCSVStarterForm1",
    GetDataToCSVFormCarr2Html: "Job/GetExportToCSVStarterForm2",
    GetExportToSFFDM: "Job/GetExportToSFFDM",
    GetEmailAlliedForm: "Job/GetEmailAlliedForm",
    GetPreviewAlliedForm: "Job/GetPreviewAlliedForm",
    GetStarterFormHtmlBPP: "Job/GetStarterFormBpp",
    GetStarterFormHtmlCCL: "Job/GetStarterFormCCL",
    GetCheckListIom: "Job/GetCheckListIom",
    GetStarterFormRadian: "Job/GetStarterFormRadian",
    SaveStarterFormRadian: "Job/SaveStarterFormRadian",
    SaveCheckListIom: "Job/SaveCheckListIom",
    GetStarterFormCCLExport: "Job/GetStarterFormCCLExport",
    GetStarterFormHtmlIom: "Job/GetStarterFormIom",
    GetStarterFormHtmlAllied: "Job/GetStarterFormAllied",
    SaveStarterForm: "Job/SaveStarterForm",
    SendStarterFormDataToiTrentNtu: "Integration/SendCandidateDataToiTrent",
    sendToHRNet: "Integration/SendToHRNet",
    sendToMistral: "Integration/SendToMistral",
    sendToESR: "Integration/SendToESR",
    DownloadEmploymentChecksJson: "Integration/DownloadEmploymentChecksJson",
    GetESRApplicationStatus: "Integration/GetESRApplicationStatus",
    GetESREmploymentChecksStatus: "Integration/GetESREmploymentChecksStatus",
    sendToITrent: "Integration/SendToITrent",
    sendToCintra: "Cintra/SendToCintra",
    reSendToCintra: "Cintra/ReSendToCintra",
    checkIsCandidateSentToCintra: "Cintra/CheckIsCandidateSentToCintra",
    sendToItrentIntegration: "ItrentIntegration/SendToItrentIntegration",
    reSendToItrentIntegration: "ItrentIntegration/ReSendToItrentIntegration",
    checkIsCandidateSentToItrentIntegration: "ItrentIntegration/CheckIsCandidateSentToItrentIntegration",
    ConfirmNewStarter: "VoyageCare/ConfirmNewStarter",
    CancelNewStarter: "VoyageCare/CancelNewStarter",
    GetCompletedStarter: "VoyageCare/GetCompletedStarter",
    SendStarterFormDataToSap: "Sap/SendCandidateDataToSap",
    SendStarterFormDataToiTrentUoBAT: "iTrentUoBAT/SendCandidateDataToiTrentUoBAT",
    SendCandidateDataToiTrentPriory: "iTrentPriory/SendCandidateDataToiTrentPriory",
    DownloadiTrentPrioryPdfDocs: "iTrentPriory/DownloadiTrentPrioryPdfDocs",
    GetCandidateDocuments: "iTrentPriory/GetCandidateDocuments",
    ExportFromHft: "HftIntegration/ExportFromHft",
    SaveStarterFormBPP: "Job/SaveStarterFormBpp",
    SaveStarterFormCCL: "Job/SaveStarterFormCCL",
    SaveStarterFormIOM: "Job/SaveStarterFormIom",
    SaveStarterFormAllied: "Job/SaveStarterFormAllied",
    SaveStarterFormSparta: "Job/SaveStarterFormSparta",
    SaveStarterExtraForm: "Job/SaveStarterForm2",
    ExportAsCSV: "Job/ExportAsCSV",
    SendStarterFormDataToCiphr: "Ciphr/SendStarterFormDataToCiphr",
    SendStarterFormDataToNhsProperty: "iTrentNhsProperty/SendCandidateDataToiTrentNhsProperty",

    sendToPeopleHR: "Integration/SendToPeopleHR",
    sendToOracle: "Integration/SendToOracle",
    queueDocPeopleHR: "Integration/QueueDocPeopleHR",
    getDocPeopleHR: "Integration/GetDocPeopleHR",
    UpdateESREmployment: "EsrIntegration/UpdateESREmployment",
    ServerSideLookUp: {
      GetLookUp: "Job/GetLookUpData"
    }


  },
  DashBoard: {
    Notification: "Talent/GetNotification",
  },
  // new SqlParameter("@UserID", _stateManagmentService.UserId),
  Reports: {
    GetReportsFilterData: "Reports/GetRportsFilterData",
    JobList: "Reports/GetJobList",
    GetHRBusinessReportData: "Reports/GetHRBusinessReportData",
    vacancyReportList: "Reports/GetVacancyReportList",
    AgencyAnalysisReportList: "Reports/GetAgencyAnalysisList",
    interViewList: "Reports/GetInterViewList",
    initialShiftList: "Reports/GetInitialShiftList",
    GetSourceList: "Reports/GetSourceTrackingList",
    GetTimeRecruit: "Reports/GetTimeToRecruitList",
    GetAdvertCostAnalysis: "Reports/GetAdvertCostAnalysisList",
    GetEqualityCommission: "Reports/GetEqualityCommissionList",
    GetCandidateStatus: "Reports/GetCandidateStatusList",
    GetAppPerWeekList: "Reports/GetApplicationPerWeekList",
    GetAppWorkFlowList: "Reports/GetWorkFlowReportList",
    GetRegestrationMethodReportList: "Reports/GetRegestrationMethodReportList",
    GetEqualOppsList: "Reports/GetEqualOppsList",
    BottleNeck: "Reports/GetBottleNeck",
    BottleNeckDetail: "Reports/GetBottleNeckDetail",
    ClientDevision: "SystemSettings/GetClienDivisions",
    GetClientDevision: "Reports/GetClientDivisions",
    GetRComparisonJobsList: "Reports/GetRComparisonJobsList",
    GetRComparisonByGroupList: "Reports/GetRComparisonByGroupList",
    CCMSRevisedCriteria: "Reports/CCMSRevisedCriteria",
    CandidateListReport: "Reports/GetCandidateListReport",
    GetDelAppWithdrawReasonsList: "Reports/GetDelAppWithdrawReasonsList",
    GetCandidateListReport: "Reports/GetCandidateReferenceList",

    GetApplicationOfferReport: "Reports/GetApplicationOfferReport",

    GetTimedAssessmentList: "Reports/GetTimedAssessmentList",
    GetTimedAssessmentByGroupList: "Reports/GetTimedAssessmentByGroupList",


    GetOnboardingReport: "Reports/GetOnboardingReport",
    GetReferenceReport: "Reports/GetReferenceReport",
    GetComplianceReport: "Reports/GetComplianceReport",
    GetBottleNeckAppicationStatus: "Reports/GetBottleNeckAppicationStatus",
    GetBottleNeckReport: "Reports/GetBottleNeckReport",
  },
  QuickLink: {
    GetQuickLinksLogo: "SystemSettings/GetClienDivisions",
    GetQuickLinksLogoAndNotifications: "SystemSettings/GetClienDivisionsAndNotification",
    GetDestopItemWithTLS: "SystemSettings/GetDestopItemWithTLS"


  },
  AddJob: {
    GetJobAccessUserLookup: "AddJob/GetJobAccessUserLookup",
    GetJobDetails: "AddJob/GetJobDetails",
    GetPreviewOnlyJobDetails: "AddJob/GetPreviewOnlyJobDetails",
    SaveJobDetails: "AddJob/SaveJobDetails/",
    SaveJobAlert: "AddJob/SaveJobAlert/",
    PostJob: "AddJob/PostJob",
    ChangeJobStatus: "AddJob/ChangeJobStatus",
    GetJobAdverts: "AddJob/GetJobAdverts",
    GetPreviewOnlyJobAdverts: "AddJob/GetPreviewOnlyJobAdverts",
    GetJobAdvertsVisibleTo: "AddJob/GetJobAdvertsVisibleTo",
    GetAdvertDetailForPreview: "AddJob/GetAdvertDetailForPreview?JobId=",
    GetSmartSearch: "AddJob/GetSmartSearch",
    ResendRequisition: "AddJob/ResendRequisition",
    ApproveRequisition: "AddJob/ApproveRequisition",
    SaveJobAdverts: "AddJob/SaveJobAdverts/",
    SaveAssesment: "AddJob/SaveAssesment/",
    SaveGuaranteedInterview: "AddJob/SaveGuaranteedInterview/",

    GetApprovalForm: "AddJob/GetApprovalForm",
    GetPreviewOnlyApprovalForm: "AddJob/GetPreviewOnlyApprovalForm",
    SaveJobDocumentApprovalForm: "AddJob/SaveJobDocumentApprovalForm",

    SaveApprovalForm: "AddJob/SaveApprovalForm",
    SaveJobNote: "AddJob/SaveJobNote",
    GetPostJobById: "AddJob/GetPostJobById?id=",
    GetESRJobDetailByJobId: "AddJob/GetESRJobDetailByJobId?id=",
    PostJobToESR: "AddJob/PostJobToESR?id=",
    GetJobInfoById: "AddJob/GetJobInfoById?id=",
    GetJobNoteById: "AddJob/GetJobNoteById?id=",
    PreviewJobNotes: "AddJob/PreviewJobNotes?id=",

    GetJobAccessById: "AddJob/GetJobAccessById?id=",
    GetJobAlertById: "AddJob/GetJobAlertById?id=",
    GetAgencyExpense: "AddJob/GetAgencyExpense?id=",
    SaveAgencyExpense: "AddJob/SaveAgencyExpense",

    SaveJobAccess: "AddJob/SaveJobAccess",
    GetJobDetailsForBroadBean: "AddJob/GetJobDetailsForBroadBean?id=",
    PostJobToBroadBean: "AddJob/PostJobToBB",
    GetJobDetailsForJobBoards: "AddJob/GetJobDetailsForJobBoards?id=",
    PostJobToJobBoards: "AddJob/PostJobToJB",
    PostJobToIdibu: "JobsAndTalents/AddJob/PostJobs/PostToIdibu",
    GetJobDetailsForCaterer: "AddJob/GetJobDetailsForCaterer?id=",
    PostJobToCaterer: "AddJob/PostJobToCaterer",
    GetJobDetailsForMonster: "AddJob/GetJobDetailsForMonster?id=",
    PostJobToMonster: "AddJob/PostJobToMonster",
    GetMonsterCountryList: "AddJob/GetMonsterCountryList",
    GetJobDetailsForReed: "AddJob/GetJobDetailsForReed?id=",

    PostJobToReed: "AddJob/PostJobToReed",
    GetJobSectors: "AddJob/GetJobSectors?id=",
    GetMonsterRegion: "AddJob/GetMonsterRegion?id=",
    GetMonsterCounty: "AddJob/GetMonsterCounty",
    AddExpenses: "AddJob/AddExpenses",
    GetJobExpense: "AddJob/GetJobExpense?id=",
    Copy: "AddJob/Copy",
    GetAssessmentScore: "AddJob/GetAssessmentScore?prams=",
    SaveAssessmentScore: "AddJob/SaveAssessmentScore",
    DeleteJobDocument: "AddJob/DeleteJobDocument",
    SaveJobDocument: "AddJob/SaveJobDocument",
    GetJobDocument: "AddJob/GetJobDocument",
    SaveCopyExternalJobDocument: "AddJob/SaveCopyExternalJobDocument",

    GetJobAssessment: "AddJob/GetJobAssessment",
    GetDivisionsByDepartments: "AddJob/GetDivisionsByDepartments/",
    GetDivisionsBySchoolLocations: "AddJob/GetDivisionsBySchoolLocations/",
    GetSchoolLocationsByDepartments: "AddJob/GetSchoolLocationsByDepartments/",
    GetCostCentresByDivisions: "AddJob/GetCostCentresByDivisions/",
    GetCampaignByDivisions: "AddJob/GetCampaignByDivisions",
    GetDivisionsBySchoolLocation: "AddJob/GetDivisionsBySchoolLocation/",

    ServerSideLookUp: {
      GetJobLookUp: "AddJob/GetLookUpData"
    },
    GetJobDetailsForTotalJobs: "AddJob/GetJobDetailsForTotalJobs?id=",
    GetMaxSalary: "AddJob/GetMaxSalary?RateUnit=",
    GetMinSalary: "AddJob/GetMinSalary?RateUnit=",
    PostJobToTotalJobs: "AddJob/PostJobToTotalJobs",
    GetJtGoPostJobById: "AddJob/GetJtGoPostJobById?id=",
    JtGoPostJob: "AddJob/JtGoPostJob",
    GetProducts: "MarketPlace/GetProducts",
    GetLocations: "MarketPlace/GetLocations",
    GetJobTitles: "MarketPlace/GetJobTitles",
    GetJobFunction: "MarketPlace/GetJobFunction",
    GetIndustries: "MarketPlace/GetIndustries",
    GetProductDetail: "MarketPlace/GetProductDetail",
    GetCheckoutDetail: "MarketPlace/GetCheckoutDetail?jobId=",
    GetCountry: "MarketPlace/GetCountries",
    GeteducationLevel: "MarketPlace/GeteducationLevel",
    SaveCheckoutDetail: "MarketPlace/SaveCheckoutDetail",
    ExportCart: "MarketPlace/ExportCart",
    GetJobDetail: "MarketPlace/GetJobDetail?jobId=",
    CheckStripeCustomerExist: "Stripe/CheckIfStripeCustomerExist",
    GetRequisitionListing: "Requisition/GetListing",
    GetUserPermission: "Requisition/UserPermission?jobId=",
    ApprovedRequisition: "Requisition/Approved?id=",
    RejectRequisition: "Requisition/Reject?id=",
    GetRequisitionStatus: "Requisition/GetRequisitionStatus",
  },
  AnonymousUser: {
    GetApprovedJob: "AnonymousUser/GetApprovedJob?pram=",
    GetApprovedRejectJobData: "AnonymousUser/GetApprovedRejectJobData?pram=",

    GetNotApprovedJobs: "AnonymousUser/GetNotApprovedJobs?pram=",
    ApproveJob: "AnonymousUser/ApproveJob",
    RejectJob: "AnonymousUser/RejectJob",

    SaveApprovedNotApprovedOffer: "AnonymousUser/SaveApprovedNotApprovedOffer",
    SaveApprovedNotApprovedGapConcern: "AnonymousUser/SaveApprovedNotApprovedGapConcern",
    GetComplianceDocumentLibraryById: "AnonymousUser/GetComplianceDocumentLibraryById?id=",
    ApprovedRejectLineManager: "AnonymousUser/ApprovedRejectLineManager?pram=",
    GetApprovedRejectLineManager: "AnonymousUser/GetApprovedRejectLineManager?pram=",
    ResetUpdateEvents: "AnonymousUser/ResetUpdateEvents",
    GetHostUrl: "LogmeInOnlineInterview/GetHostUrl?InterviewGuid=",
    StartMeeting: "LogmeInOnlineInterview/StartMeeting?InterviewGuid=",
    LoadLoginConfiguration: "AnonymousUser/LoadLoginConfiguration"
  },
  CompliaceSettings: {
    GetCompliaceSettings: "OnBoarding/GetComplianceSettings",
    Save: "OnBoarding/SaveComplianceSettings",
    NameParams: "&controllerName=",
    DeleteCheckList: "OnBoarding/DeleteCheckListCompliance?id=",
    GetCompliaceStatuses: "OnBoarding/GetComplianceSettingsStatuses",
    GetOBManagersList: "OnBoarding/GetOBManagersList",
    GetOBManagersById: "OnBoarding/GetOBManagersById?id=",
    GetMediaLibraryList: "OnBoarding/GetMediaLibraryCSList",
    GetMediaLibraryById: "OnBoarding/GetMediaLibraryCSById?id=",
  },
  DocumentLibraryCompliance: {
    GetDocumentLibrariesListCompliance: "OnBoarding/GetDocumentLibrariesListCompliance",
    Save: "OnBoarding/SaveDocumentLibrariesCompliance",
    GetById: "OnBoarding/GetDocumentLibrariesByIdCompliance?id=",
    Archived: "OnBoarding/ArchiveDocumentLibrariesCompliance",
    NameParams: "&controllerName=",
  },


  CompliaceTemplates: {
    GetTemplatesList: "OnBoarding/GetComplianceTemplatesList",
    SaveTemplates: "OnBoarding/SaveComplianceTemplates",
    SaveTemplatesDocuments: "OnBoarding/SaveComplianceTemplatesDocuments",
    GetTemplatesById: "OnBoarding/GetComplianceTemplatesById",
    GetTemplates: "OnBoarding/GetSystemTemplatesCompliance",
    GetDocumentById: "OnBoarding/GetComplianceDocumentLibraryById?id=",
    Archived: "OnBoarding/ArchiveComplianceTemplates",
    NameParams: "&controllerName=",
    CopyComplianceTemplate: "OnBoarding/CopyComplianceTemplate",
    GetComplianceContract: "OnBoarding/GetComplianceContract?id=",

  },

  OnBoardingNotifications: {
    GetOnBoardingNotifications: "OnBoarding/GetOnBoardingNotifications",
  },

  NHSJob3: {
    GetJobDetailForNhsJob: "AddJob/GetJobDetailForNhsJob?id=",
    DeleteJobFromNHSJob: "AddJob/DeleteJobFromNHSJob?id=",
    PostJobToNhsJobs: "AddJob/PostJobToNhsJobs",
  },


  Thirteen: {
    GetThirteenDocuments: "Thirteen/GetCandidateThirteenDocuments",
    QueueThirteenDocuments: "Thirteen/QueueThirteenDocuments",
    ReQueueThirteenDocuments: "Thirteen/ReQueueThirteenDocuments",
    CreateCominedPDFDocument: "Thirteen/CreateCominedPDFDocument",
    CheckAllPrioryDocumentConverted: "Thirteen/CheckAllPrioryDocumentConverted",

  },


  BrandBuilderSetup: {
    GetSystemSites: "SystemSettings/GetSystemSites",
    BrandBuilderLogin: "SystemSettings/BrandBuilderLogin"
  },

  TwoFactorAuthentificatoin: {
    EmailCode: "Login/EmailCode?id=",
    VerifyEmailCode: "Login/VerifyEmailCode",
    GetQrCode: "Login/GetQrCode"
  },
  IdentityCheckYoti: {
    GetCandidateDetail: "Yoti/GetCandidateDetail",
    StartIdentityCheck: "Yoti/StartIdentityCheck",
    ApproveRejectIdentityCheck: "Yoti/ApproveRejectIdentityCheck",
    GetIdentityCheckDetails: "Yoti/GetIdentityCheckDetails",
    GetIdentityCheckHistory: "Yoti/GetIdentityCheckHistory",
    GetIdentityCheckReport: "Yoti/GetIdentityCheckReport",
    GetIdentityCheckHistoryDetail: "Yoti/GetIdentityCheckHistoryDetail",
    RestartIdentityCheck: "Yoti/RestartIdentityCheck",

    },
    Redeployments: {
        GetRedeploymentStatus: "Redeployment/GetRedeploymentStatus",
        SaveRedeploymentStatus: "Redeployment/SaveRedeploymentStatus",
        GetRedeploymentStatusById: "Redeployment/GetRedeploymentStatusById?id=",
        ArchiveRedeploymentStatus: "Redeployment/ArchiveRedeploymentStatus",
        GetRedeploymentStatusLookUp: "Redeployment/GetRedeploymentStatusLookUp",
        GetListing: "RedeploymentForm/GetListing",
        Save: "RedeploymentForm/Save",
        Delete: "RedeploymentForm/Delete",
        GetTalentApplicationCount: "RedeploymentForm/GetTalentApplicationCount",
      IsDuplicateTalentApplicationForm: "RedeploymentForm/IsDuplicateTalentApplicationForm?applicationFormId=",
      GetRedeploymentFormDeclaration: "RedeploymentForm/GetRedeploymentFormDeclaration",
      GetRedeploymentDeclarationFromCases: "RedeploymentForm/GetRedeploymentDeclarationFromCases",
      SaveRedeploymentFormDeclaration: "RedeploymentForm/SaveRedeploymentFormDeclaration",

    },
    NTUDocumentsExport: {
        GetCandidateApplications: "NTUDocumentsExport/GetCandidateApplications",
        QueuedDocuments: "NTUDocumentsExport/QueuedDocuments",
        GetCombinedPdfExtract: "NTUDocumentsExport/GetCombinedPdfExtract",
        CheckAllDocumentConverted: "NTUDocumentsExport/CheckAllDocumentConverted",
        GetCandidateApplicationsFromPrioryDocuments: "NTUDocumentsExport/GetCandidateApplicationsFromPrioryDocuments",
        ConvertAndStitchDocuments: "NTUDocumentsExport/ConvertAndStitchDocuments"
    },
    ReportBuilder: {
        GetPublicReports: "ReportBuilder/GetPublicReports",
        publicReportLibrary: "ReportBuilder/publicReportLibrary",
        ArchivePublicReports: "ReportBuilder/ArchivePublicReports",
        GetMyReports: "ReportBuilder/GetMyReports",
        RemoveMyReport: "ReportBuilder/RemoveMyReport",
        GetRemainingMyReportsCount: "ReportBuilder/GetRemainingMyReportsCount",
        GetDataSources: "ReportBuilder/GetDataSources",
        GetDataSourceFields: "ReportBuilder/GetDataSourceFields",
        GetFilterParameters: "ReportBuilder/GetFilterParameters",
        GetFilterOptions: "ReportBuilder/GetFilterOptions",
        AddToMyReports: "ReportBuilder/AddToMyReports",
        UnArchivePublicReports: "ReportBuilder/UnArchivePublicReports",
        GetDataForReportPreview: "ReportBuilder/GetDataForReportPreview?reportId=",
        SaveReport: "ReportBuilder/SaveReport",
        RunReport: "ReportBuilder/RunReport",
      GetReport: "ReportBuilder/GetReport"
    },
    ReportBuilderLookup: {
        GetDataSourceLookup: "ReportBuilderLookup/GetDataSource",
        GetReportTypeLookup: "ReportBuilderLookup/GetReportType",
        GetPublicReportLookup: "ReportBuilderLookup/GetPublicReport",
      GetSystemGender: "ReportBuilderLookup/GetSystemGender",
      EthnicOrigins: "ReportBuilderLookup/GetEthnicOrigins",
      GetSystemMaritalStatus: "ReportBuilderLookup/GetSystemMaritalStatus",
      GetSystemNationalities: "ReportBuilderLookup/GetSystemNationalities",
      GetSystemReasonForVacancies: "ReportBuilderLookup/GetSystemReasonForVacancies",
      GetSystemAgeRanges: "ReportBuilderLookup/GetSystemAgeRanges",
      GetSystemSexOrientation: "ReportBuilderLookup/GetSystemSexOrientation",
      GetSalaryBands: "ReportBuilderLookup/GetSalaryBands",
      GetCostCentres: "ReportBuilderLookup/GetCostCentres/",
      GetSalaryRanges: "ReportBuilderLookup/GetSalaryRanges/",
      GetStatusChangeReasons: "ReportBuilderLookup/GetStatusChangeReasons/",
      GetDeleteAppWithdrawReasons: "ReportBuilderLookup/GetDeleteAppWithdrawReasons/",
      GetRecruiterLookup: "ReportBuilderLookup/GetRecruiterLookup/",
      GetSkillsLookup: "ReportBuilderLookup/GetSkillsLookup/",
      GetStatusGroups: "ReportBuilderLookup/GetStatusGroups/"
    },

    DataLake: {
        GetUniversalAdvertSourcesLookUp: "DataLake/GetUniversalAdvertSourcesLookUp",
    }

}
